import {
  BusinessPartnerSubGroupAttributes,
  CompanyAttributes,
  ShortSubRouteAttributes,
  StatusEnum,
  UserFieldConfigAttributes,
} from "@albatrosdeveloper/ave-models-package";
import { PermissionModeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/permission-gps.enum";
import { UserFieldEntityTypeEnum } from "@albatrosdeveloper/ave-models-package/lib/enums/user-field-entity-type.enum";
import BusinessPartnerGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-group/business-partner-group.entity";
import BusinessPartnerTypeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner-type/business-partner-type.entity";
import BusinessPartnerAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity";
import DistributionChainAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/distribution-chain/distribution-chain.entity";
import SalesOfficeAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/configurations/sales-office/sales-office.entity";
import PaymentConditionAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/payment-condition/payment-condition.entity";
import RequirementAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/masters/requirements/requirements.entity";
import MaterialGroupAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/materials/material-group/material-group.entity";
import RouteAreaAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route-area/route-area.entity";
import ShortRouteAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/routing/route/short-route/route.short.entity";
import RouteAttributes from "@albatrosdeveloper/ave-models-package/src/schemas/routing/route/route.entity";
import { CommonModule } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  inject,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { MatCheckbox } from "@angular/material/checkbox";
import { MatOptionModule } from "@angular/material/core";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatDividerModule } from "@angular/material/divider";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from "@angular/material/menu";
import {
  MatPaginator,
  MatPaginatorIntl,
  MatPaginatorModule,
  PageEvent,
} from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenavContainer } from "@angular/material/sidenav";
import {
  MatSlideToggle,
  MatSlideToggleChange,
} from "@angular/material/slide-toggle";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatRowDef, MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatTooltipModule } from "@angular/material/tooltip";
import { ActivatedRoute, Router } from "@angular/router";
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import {
  NgLabelTemplateDirective,
  NgSelectComponent,
} from "@ng-select/ng-select";
import { TranslocoModule } from "@ngneat/transloco";
import { FilterComponent } from "app/common/components/filter/filter.component";
import { IRequestResult } from "app/common/interfaces";
import { HandlerMessageService } from "app/common/services/handler-error/handler-message.service";
import { SearchService } from "app/layout/common/search-page/search-page.service";
import { ExportFileFormat, ExportRange } from "app/layout/export-overlay";
import { ExportDialogComponent } from "app/layout/export-overlay/dialog/export-dialog.component";
import { ExportOptions } from "app/layout/export-overlay/tasks/core/export-task.interfaces";
import { CustomMatPaginatorIntl } from "app/mock-api/common/customPaginatorIntl";
import { CompanyCurrencyPipe } from "app/pipes/currency.pipe";
import { MonedaPipe } from "app/pipes/moneda.pipe";
import { BusinessPartnerTypeEnum } from "app/shared/components/business-partner-display/business-partner-type.enum";
import { ExportAddressesDialogComponent } from "app/shared/components/business-partner-routes/business-partner-routes.component";
import { ConfirmationModalType } from "app/shared/components/confirmation-modal";
import { ExcelGeneratorService } from "app/shared/components/excel-import";
import { ImportDialogComponent } from "app/shared/components/excel-import/components/import-dialog/import-dialog.component";
import { ImportConfig } from "app/shared/components/excel-import/interfaces/import-config.interface";
import { FormSectionComponent } from "app/shared/components/form-ui/form-section/form-section.component";
import { MapModalComponent } from "app/shared/components/map-modal/map-modal.component";
import {
  MapModalTypeEnum,
  MonitorDocumentTypeEnum,
} from "app/shared/components/map-modal/models/map-modal.enum";
import { MapModalInputData } from "app/shared/components/map-modal/models/map-modal.interface";
import { ConfirmationService } from "app/shared/services/confirmation.service";
import { getCode } from "app/utils/method";
import { environment } from "environments/environment.prod";
import { has, isObject } from "lodash";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import {
  ReplaySubject,
  Subject,
  Subscription,
  switchMap,
  take,
  takeUntil,
} from "rxjs";
import { CompanyFieldCatalogService } from "../../configuration/company/company-form-config/company-form-config.service";
import { CompanyService } from "../../configuration/company/company.service.service";
import { UserFieldsConfigurationComponent } from "../../configuration/company/user-fields-configuration/user-fields-configuration.component";
import { SalesOfficeService } from "../../configuration/sales-office/sales-office.service";
import { BusinessPartnersFiltersComponent } from "../../filters/business-partners-filters/business-partners-filters.component";
import { ConfigurationFiltersComponent } from "../../filters/configuration-filters/configuration-filters.component";
import { IFilters } from "../../filters/interfaces/filterInterface";
import { RoutesFiltersComponent } from "../../filters/routes-filters/routes-filters.component";
import { StatusFiltersComponent } from "../../filters/status-filters/status-filters.component";
import { PaymentConditionService } from "../../master/payment-condition/payment-condition.service";
import { RequirementService } from "../../master/requirement/requirement.service";
import { MaterialGroupService } from "../../material/material-group/material-group.service";
import { RoutesDetailByBusinessPartnerVehicleComponent } from "../../modals/routes-detail-by-business-partner-vehicle/routes-detail-by-business-partner-vehicle/routes-detail-by-business-partner-vehicle.component";
import { RouteAreaService } from "../../routing/route-area/route-area.service";
import { RouteService } from "../../routing/route/route.service";
import {
  SUB_ROUTE_IMPORT_FILE_FULL_URL,
  SubRouteService,
} from "../../routing/sub-routes/sub-route.service";
import { ModalMapComponent } from "../../shared/modal-map/modal-map.component";
import { BusinesPartnerGeoDialogComponent } from "../busines-partner-geo-dialog/busines-partner-geo-dialog.component";
import { BusinessPartnerGroupService } from "../business-partner-group/business-partner-group.service";
import { BusinessPartnerSubGroupService } from "../business-partner-sub-group/business-partner-sub-group.service";
import { BusinessPartnerTypeService } from "../business-partner-type/business-partner-type.service";
import { AddBusinessPartnerAddressComponent } from "./business-partner-address-modal/business-partner-address.component";
import { BusinessPartnerAddressService } from "./business-partner-address-modal/business-partner-address.component.service";
import { AddBusinessPartnerContactComponent } from "./business-partner-contact-modal/business-partner-contact.component";
import { BusinessPartnerContactService } from "./business-partner-contact-modal/business-partner-contact.component.service";
import { AddBusinessPartnerEmailComponent } from "./business-partner-email-modal/business-partner-email.component";
import { BusinessPartnerEmailService } from "./business-partner-email-modal/business-partner-email.service";
import { AddBusinessPartnerOrderComponent } from "./business-partner-order-modal/business-partner-order.component";
import { BusinessPartnerOrderService } from "./business-partner-order-modal/business-partner-order.service";
import { AddBusinessPartnerPhoneComponent } from "./business-partner-phone-modal/business-partner-phone.component";
import { BusinessPartnerPhoneService } from "./business-partner-phone-modal/business-partner-phone.service";
import { BusinessPartnerPriceListComponent } from "./business-partner-price-list-modal/business-partner-price-list-modal.component";
import { BusinessPartnerScheduleComponent } from "./business-partner-schedule-modal/business-partner-schedule.component";
import {
  BUSINESS_PARTNER_IMPORT_ADDRESS_LINK,
  BusinessPartnerService,
} from "./business-partner.service";
import { DeleteConfirmationComponent } from "./delete-modal/delete-modal.component";
import { AddInterlocutorComponent } from "./distribution-chain-interlocutor-modal/distribution-chain-interlocutor.component";
import { BusinessPartnerInterlocutorService } from "./distribution-chain-interlocutor-modal/distribution-chain-interlocutor.component.service";
import { AddDistributionChainComponent } from "./distribution-chain-modal/distribution-chain.component";
import { BusinessPartnerDistributionService } from "./distribution-chain-modal/distribution-chain.component.service";
import { BusinessPartnerAddressExport } from "./exports/business-partner-address.export";
import { BusinessPartnerByOneAddressExport } from "./exports/business-partner-by-one-address.export";
import { BUSINESS_PARTNER_TITLE } from "./exports/business-partner.constants";
import { BusinessPartnerExport } from "./exports/business-partner.export";
import { AddresExportComponent } from "./exports/export-address/export-address.component";
import { ICreateBusinessPartner } from "./interfaces/create-business-partner.interface";
import { IUpdateBusinessPartner } from "./interfaces/update-business-partner.interface";
import { SettingUserComponent } from "./setting-user/setting-user.component";

function findByKey(obj, targetKey) {
  // Check if current level has the key
  if (has(obj, targetKey)) {
    return obj[targetKey];
  }

  // Recursively search in nested objects
  for (const value of Object.values(obj)) {
    if (isObject(value)) {
      const found = findByKey(value, targetKey);
      if (found) return found;
    }
  }

  return null;
}

@Component({
  selector: "app-business-partner",
  standalone: true,
  templateUrl: "./business-partner.component.html",
  styleUrl: "./business-partner.component.scss",
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatTabsModule,
    TranslocoModule,
    NgxMatSelectSearchModule,
    MonedaPipe,
    MatDividerModule,
    MatRadioModule,
    MatCheckbox,
    FilterComponent,
    MatButtonToggleModule,
    StatusFiltersComponent,
    BusinessPartnersFiltersComponent,
    ConfigurationFiltersComponent,
    RoutesDetailByBusinessPartnerVehicleComponent,
    HoverMenuDirective,
    RoutesFiltersComponent,
    FormSectionComponent,
    UserFieldsConfigurationComponent,
    CompanyCurrencyPipe,
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    BusinessPartnerExport,
    BusinessPartnerAddressExport,
    BusinessPartnerByOneAddressExport,
  ],
})
export class BusinessPartnerComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  private _matDialog = inject(MatDialog);
  public typeSearchCtrl: FormControl<string> = new FormControl<string>("");

  getCode = getCode;
  displayedColumns: string[] = [
    "addresses",
    "name",
    "type",
    "creditLimit",
    "statusId",
    "actions",
  ];
  displayedColumnsChain: string[] = ["name", "channel", "statusId", "actions"];
  displayedColumnsEditInterlocutor: string[] = [
    "code",
    "name",
    "function",
    "statusId",
    "actions",
  ];
  displayedColumnsContact: string[] = [
    "name",
    "lastName",
    "statusId",
    "actions",
  ];
  displayedColumnsAddress: string[] = [
    "name",
    "address",
    "geolocationPoint",
    "statusId",
    "actions",
  ];
  displayedColumnsEmail: string[] = ["email", "statusId", "actions"];
  displayedColumnsPhone: string[] = ["prefix", "statusId", "actions"];
  displayedColumnsOrder: string[] = [
    "days",
    "hourStart",
    "hourEnd",
    "statusId",
    "actions",
  ];
  currentCreateBusinessPartner: ICreateBusinessPartner =
    this.initializeCreateBusinessPartner();
  currentUpdateBusinessPartner: BusinessPartnerAttributes | undefined;
  currentDistributionChain: DistributionChainAttributes | undefined;

  selectedCompanyIds: string[] = [];
  selectedRol: string[] = [];
  selectedTypeCodes: string[] = [];
  selectedDivisionIds: string[] = [];
  selectfatherCode: string[] = [];

  isInterlocutorTabEnabled = false;
  selectedTabIndex = 0;
  interlocutorsDataSource: any[] = [];
  isInterlocutorTabVisible = false;

  dataSource: BusinessPartnerAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  requirementList: RequirementAttributes[] = [];
  paymentConditionList: PaymentConditionAttributes[] = [];
  routeAreaList: RouteAreaAttributes[] = [];
  businessGroupList: BusinessPartnerGroupAttributes[] = [];
  businessSubGroupList: BusinessPartnerSubGroupAttributes[] = [];
  listFilterBusinessSubGroup: BusinessPartnerSubGroupAttributes[] = [];
  salesOfficeList: SalesOfficeAttributes[] = [];
  rutaList: RouteAttributes[] = [];
  businessPartnerTypeList: BusinessPartnerTypeAttributes[] = [];
  businessPartnerFilterTypeList: BusinessPartnerTypeAttributes[] = [];

  daysList: { day: string; value: number }[] = [
    { day: "Lunes", value: 1 },
    { day: "Martes", value: 2 },
    { day: "Miércoles", value: 3 },
    { day: "Jueves", value: 4 },
    { day: "Viernes", value: 5 },
    { day: "Sábado", value: 6 },
    { day: "Domingo", value: 7 },
  ];

  rolList: { code: string; name: string }[] = [
    { code: "Em", name: "Empleados" },
    { code: "Ex", name: "Externos" },
  ];

  searchQuery: string = "";
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 1;

  /** control for the selected route for multi-selection */
  public routeMultiCtrl: FormControl<ShortRouteAttributes[]> = new FormControl<
    ShortRouteAttributes[]
  >([]);

  /** control for the MatSelect filter keyword multi-selection */
  public routeMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of route filtered by search keyword */
  public filteredRoutes: ReplaySubject<ShortRouteAttributes[]> =
    new ReplaySubject<ShortRouteAttributes[]>(1);

  /** local copy of filtered route to help set the toggle all checkbox state */
  protected filteredRouteCache: ShortRouteAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  /** control for the selected company for multi-selection */
  public companyMultiCtrl: FormControl<CompanyAttributes[]> = new FormControl<
    CompanyAttributes[]
  >([]);

  /** control for the MatSelect filter keyword multi-selection */
  public companyMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of company filtered by search keyword */
  public filteredCompany: ReplaySubject<CompanyAttributes[]> =
    new ReplaySubject<CompanyAttributes[]>(1);

  /** local copy of filtered company to help set the toggle all checkbox state */
  protected filteredCompanyCache: CompanyAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminateComp = false;
  isCheckedComp = false;

  // public filteredTypes: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]); // Lista filtrada
  public typeList: any[] = []; // Lista completa de tipos

  /** control for the selected type for multi-selection */
  public typeMultiCtrl: FormControl<BusinessPartnerTypeAttributes[]> =
    new FormControl<BusinessPartnerTypeAttributes[]>([]);

  /** control for the MatSelect filter keyword multi-selection */
  public typeMultiFilterCtrl: FormControl<string> = new FormControl<string>("");

  /** list of type filtered by search keyword */
  public filteredType: ReplaySubject<BusinessPartnerTypeAttributes[]> =
    new ReplaySubject<BusinessPartnerTypeAttributes[]>(1);

  /** local copy of filtered type to help set the toggle all checkbox state */
  protected filteredTypeCache: BusinessPartnerTypeAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminateType = false;
  isCheckedType = false;
  isSeller: boolean = false;
  isRtnRequired: boolean = true;

  /** control for the selected requirement for multi-selection */
  public requirementMultiCtrl: FormControl<RequirementAttributes[]> =
    new FormControl<RequirementAttributes[]>([]);

  /** control for the MatSelect filter keyword multi-selection */
  public requirementMultiFilterCtrl: FormControl<string> =
    new FormControl<string>("");

  /** list of route filtered by search keyword */
  public filteredRequirement: ReplaySubject<RequirementAttributes[]> =
    new ReplaySubject<RequirementAttributes[]>(1);

  /** local copy of filtered requirement to help set the toggle all checkbox state */
  protected filteredRequirementCache: RequirementAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminateReq = false;
  isCheckedReq = false;

  importType: "route" | "address" | null = null;
  fileToUpload: File;
  aux_file = false;
  selectedOption: any[] = [];
  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit: MatDialogRef<any>;
  isUpdating: boolean = false;

  RTN_OPTIONAL_TYPES = [
    BusinessPartnerTypeEnum.CONSUMIDOR_FINAL,
    BusinessPartnerTypeEnum.CLIENTE_EVENTUAL,
  ];

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;

  selectedSubRoute: ShortSubRouteAttributes | null = null;

  protected _onDestroy = new Subject<void>();

  geolocationFilter: "both" | "not_registered" | "valid" = "both";

  materialGroupList: MaterialGroupAttributes[] = [];
  //arbol
  isProjectTree: boolean = environment.projectName == "CORTIJO" ? false : true;
  listCategories: any[] = [];
  listFilterCategories: any[] = [];
  searchMaterialGroup = "";
  materialGroupFilterList: any[] = [];
  categoryPrincipal: any = {
    code: "0",
    name: "Principal",
    fatherCode: "0",
    hasSubcategories: true,
    level: 0,
    expandable: true,
  };

  /** control for the selected group for multi-selection */
  public groupMultiCtrl: FormControl<MaterialGroupAttributes[]> =
    new FormControl<MaterialGroupAttributes[]>([], Validators.required);

  /** control for the MatSelect filter keyword multi-selection */
  public groupMultiFilterCtrl: FormControl<string> = new FormControl<string>(
    ""
  );

  /** list of group filtered by search keyword */
  public filteredGroup: ReplaySubject<MaterialGroupAttributes[]> =
    new ReplaySubject<MaterialGroupAttributes[]>(1);

  /** local copy of filtered group  to help set the toggle all checkbox state */
  protected filteredGroupCache: MaterialGroupAttributes[] = [];

  /** flags to set the toggle all checkbox state */
  isIndeterminateGroup = false;
  isCheckedGroup = false;

  public subMultiCtrl = new FormControl([]);

  //BUSCADOR
  searchSubscription: Subscription;
  subs: Subscription[] = [];

  isActive: number = 1;

  selectedStatuses: number[] = [];
  selectedCustomerType: string[] = [];
  form: FormGroup;

  // Lazy loading flags
  loadFiltersData = false;
  private companiesLoaded = false;
  private businessTypesFilterLoaded = false;
  private modalDataLoaded = false;

  useGpsList: { key: string; value: PermissionModeEnum }[] = [];

  // Import Excel Configuration for Ruteo (Routing)
  businessPartnerRuteoImportConfig: ImportConfig = {
    title: "para cliente-territorio",
    backendSheetName: "Cliente-Territorio",
    columns: [
      {
        key: "codigo_cliente",
        displayName: "Código Cliente",
        required: true,
        dataType: "string",
        excelColumnName: "Codigo_Cliente",
        validation: [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
        ],
        sticky: true,
        isIdentifier: true,
        identifierEntity: "customer",
        relatedColumns: ["nombre_cliente"],
      },
      {
        key: "nombre_cliente",
        displayName: "Nombre Cliente",
        required: false,
        dataType: "string",
        excelColumnName: "Nombre_Cliente",
      },
      {
        key: "codigo_direccion",
        displayName: "Código Dirección",
        required: true,
        dataType: "string",
        excelColumnName: "Codigo_Dirección",
        validation: [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
        ],
      },
      {
        key: "nombre_direccion",
        displayName: "Dirección",
        required: false,
        dataType: "string",
        excelColumnName: "Direccion",
      },
      {
        key: "razon_social",
        displayName: "Razón Social",
        required: false,
        dataType: "string",
        excelColumnName: "Razon_Social",
        validation: [Validators.maxLength(255)],
      },
      {
        key: "ruc_dni",
        displayName: "RUC/DNI",
        required: false,
        dataType: "string",
        excelColumnName: "RUC_DNI",
        validation: [Validators.maxLength(20)],
      },
      {
        key: "telefono",
        displayName: "Teléfono",
        required: false,
        dataType: "string",
        excelColumnName: "Telefono",
        validation: [Validators.maxLength(20)],
      },
      {
        key: "email_contacto",
        displayName: "Email de Contacto",
        required: false,
        dataType: "string",
        excelColumnName: "Email_de_Contato",
        validation: [Validators.email],
      },
      {
        key: "territory",
        displayName: "Codigo Territorio",
        required: true,
        dataType: "string",
        excelColumnName: "Territorio",
        validation: [Validators.required, Validators.maxLength(100)],
        isIdentifier: true,
        identifierEntity: "territory",
        relatedColumns: ["name"],
      },
      {
        key: "name",
        displayName: "Territorio",
        required: false,
        dataType: "string",
        excelColumnName: "Nombre_Territorio",
      },
      {
        key: "codigo_almacen",
        displayName: "Código Almacén",
        required: false,
        dataType: "string",
        excelColumnName: "Codigo_Almacen",
        validation: [Validators.maxLength(20)],
      },
      {
        key: "ubigeo",
        displayName: "Ubigeo",
        required: false,
        dataType: "string",
        excelColumnName: "Ubigeo",
        validation: [Validators.maxLength(20)],
      },
      {
        key: "longitud",
        displayName: "Longitud",
        required: false,
        dataType: "number",
        excelColumnName: "LONGITUD",
        validation: [Validators.min(-180), Validators.max(180)],
      },
      {
        key: "latitud",
        displayName: "Latitud",
        required: false,
        dataType: "number",
        excelColumnName: "LATITUD",
        validation: [Validators.min(-90), Validators.max(90)],
      },
      {
        key: "es_principal",
        displayName: "Principal",
        required: false,
        dataType: "string",
        excelColumnName: "Es_Principal",
        validation: [Validators.pattern(/^(SI|SÍ|NO|YES|NO|TRUE|FALSE|1|0)$/i)],
      },
      {
        key: "es_principal_socio",
        displayName: "Principal Socio",
        required: false,
        dataType: "string",
        excelColumnName: "Es_Principal_Socio",
        validation: [Validators.pattern(/^(SI|SÍ|NO|YES|NO|TRUE|FALSE|1|0)$/i)],
      },
      {
        key: "action",
        displayName: "Acción",
        required: true,
        dataType: "string",
        excelColumnName: "Acción",
        validation: [
          Validators.required,
          Validators.pattern(
            /^(Asignación única|Extender asignación|Remover de todo)$/i
          ),
        ],
      },
    ],
    apiEndpoint: SUB_ROUTE_IMPORT_FILE_FULL_URL,
    maxFileSize: 10 * 1024 * 1024, // 10MB
    acceptedFileTypes: [".xlsx", ".xls"],
    customImportHandler: (data: any[], metadata?: any) =>
      this.handleBusinessPartnerRuteoImport(data, metadata),
  };

  // Import Excel Configuration for Cliente-Frecuencia-Ruta
  clienteFrecuenciaImportConfig: ImportConfig = {
    title: "para cliente-frecuencia-ruta",
    backendSheetName: "Cliente-Frecuencia-Ruta",
    columns: [
      {
        key: "codigo_cliente",
        displayName: "Código Cliente",
        required: true,
        dataType: "string",
        excelColumnName: "Codigo_Cliente",
        validation: [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(50),
        ],
        sticky: true,
      },
      {
        key: "razon_social",
        displayName: "Razón Social",
        required: false,
        dataType: "string",
        excelColumnName: "Razon_Social",
        validation: [Validators.maxLength(255)],
      },
      {
        key: "ruc_dni",
        displayName: "RUC/DNI",
        required: false,
        dataType: "string",
        excelColumnName: "RUC_DNI",
        validation: [Validators.maxLength(20)],
      },
      {
        key: "telefono",
        displayName: "Teléfono",
        required: false,
        dataType: "string",
        excelColumnName: "Telefono",
        validation: [Validators.maxLength(20)],
      },
      {
        key: "email_contacto",
        displayName: "Email de Contacto",
        required: false,
        dataType: "string",
        excelColumnName: "Email_de_Contato",
        validation: [Validators.email],
      },
      {
        key: "codigo_ruta",
        displayName: "Código Ruta",
        required: true,
        dataType: "string",
        excelColumnName: "Codigo_Ruta",
        validation: [Validators.required, Validators.maxLength(50)],
      },
      {
        key: "codigo_almacen",
        displayName: "Código Almacén",
        required: false,
        dataType: "string",
        excelColumnName: "Codigo_Almacen",
        validation: [Validators.maxLength(100)],
      },
      {
        key: "ubigeo",
        displayName: "Ubigeo",
        required: false,
        dataType: "string",
        excelColumnName: "Ubigeo",
        validation: [Validators.maxLength(100)],
      },
      {
        key: "direccion",
        displayName: "Dirección",
        required: false,
        dataType: "string",
        excelColumnName: "Direccion",
        validation: [Validators.maxLength(500)],
      },
      {
        key: "longitud",
        displayName: "Longitud",
        required: false,
        dataType: "number",
        excelColumnName: "LONGITUD",
        validation: [Validators.min(-180), Validators.max(180)],
      },
      {
        key: "latitud",
        displayName: "Latitud",
        required: false,
        dataType: "number",
        excelColumnName: "LATITUD",
        validation: [Validators.min(-90), Validators.max(90)],
      },
      {
        key: "dia_visita",
        displayName: "Día de Visita",
        required: true,
        dataType: "string",
        excelColumnName: "DIA DE VISITA",
        validation: [Validators.required],
      },
      {
        key: "visita",
        displayName: "Visita",
        required: true,
        dataType: "string",
        excelColumnName: "VISITA",
        validation: [Validators.required],
      },
      {
        key: "action",
        displayName: "Acción",
        required: true,
        dataType: "string",
        excelColumnName: "Acción",
        validation: [
          Validators.required,
          Validators.pattern(
            /^(Asignación única|Extender asignación|Remover de todo)$/i
          ),
        ],
      },
    ],
    apiEndpoint: SUB_ROUTE_IMPORT_FILE_FULL_URL,
    maxFileSize: 10 * 1024 * 1024, // 10MB
    acceptedFileTypes: [".xlsx", ".xls"],
    customImportHandler: (data: any[], metadata?: any) =>
      this.handleClienteFrecuenciaImport(data, metadata),
  };

  // Import Excel Configuration for Direcciones (Addresses)
  businessPartnerDireccionesImportConfig: ImportConfig = {
    title: "para direcciones",
    backendSheetName: "Direcciones de Socios de Negoci",
    columns: [
      {
        key: "codigo_cliente",
        displayName: "Código",
        required: true,
        dataType: "string",
        excelColumnName: "Código",
        validation: [Validators.maxLength(50)],
      },
      {
        key: "nombre",
        displayName: "Nombre",
        required: false,
        dataType: "string",
        excelColumnName: "Nombre",
        validation: [Validators.maxLength(255)],
      },
      {
        key: "address",
        displayName: "Dirección",
        required: true,
        dataType: "string",
        excelColumnName: "Dirección",
        validation: [Validators.maxLength(500)],
      },
      {
        key: "latitud",
        displayName: "Latitud",
        required: false,
        dataType: "number",
        excelColumnName: "Latitud",
        validation: [Validators.min(-90), Validators.max(90)],
      },
      {
        key: "longitud",
        displayName: "Longitud",
        required: false,
        dataType: "number",
        excelColumnName: "Longitud",
        validation: [Validators.min(-180), Validators.max(180)],
      },
      {
        key: "tipo_direccion",
        displayName: "Tipo de Dirección",
        required: false,
        dataType: "string",
        excelColumnName: "Tipo de Dirección",
        validation: [Validators.maxLength(100)],
      },
      {
        key: "country",
        displayName: "País",
        required: true,
        dataType: "string",
        excelColumnName: "País",
        validation: [Validators.maxLength(100)],
      },
      {
        key: "state",
        displayName: "Departamento",
        required: true,
        dataType: "string",
        excelColumnName: "Departamento",
        validation: [Validators.maxLength(100)],
      },
      {
        key: "city",
        displayName: "Ciudad",
        required: true,
        dataType: "string",
        excelColumnName: "Ciudad",
        validation: [Validators.maxLength(100)],
      },
      {
        key: "principal",
        displayName: "Principal",
        required: false,
        dataType: "string",
        excelColumnName: "Principal",
        validation: [Validators.pattern(/^(SI|SÍ|NO|YES|NO|TRUE|FALSE|1|0)$/i)],
      },
    ],
    apiEndpoint: BUSINESS_PARTNER_IMPORT_ADDRESS_LINK,
    maxFileSize: 10 * 1024 * 1024, // 10MB
    acceptedFileTypes: [".xlsx", ".xls"],
    customImportHandler: (data, metadata?: any) =>
      this.handleBusinessPartnerDireccionesImport(data, metadata),
  };

  @ViewChild("routesModal") routesModal!: TemplateRef<any>;
  @ViewChild("tripsModal") tripsModal!: TemplateRef<any>;

  dialogRefRoutesDetail: MatDialogRef<any>;
  dialogRefTripsDetail: MatDialogRef<any>;

  businessParnerIdSelected: string[] = [];
  fieldsMasterData: UserFieldConfigAttributes[] = [];
  fieldsMasterDataStatus: StatusEnum;

  openRoutesModal(business_partner: BusinessPartnerAttributes): void {
    this.businessParnerIdSelected = [];
    this.businessParnerIdSelected.push(business_partner._id.toString());
    this.dialogRefRoutesDetail = this.dialog.open(this.routesModal, {
      disableClose: true,
      width: "1200px",
      maxHeight: "800px",
    });
    this.dialogRefRoutesDetail.afterClosed().subscribe((result) => {
      result;
    });
  }

  openTripsModal(business_partner: BusinessPartnerAttributes): void {
    this.businessParnerIdSelected = [];
    this.businessParnerIdSelected.push(business_partner._id.toString());
    this.dialogRefTripsDetail = this.dialog.open(this.tripsModal, {
      disableClose: true,
      width: "1200px",
      maxHeight: "800px",
    });
    this.dialogRefTripsDetail.afterClosed().subscribe((result) => {
      result;
    });
  }

  // Custom handler for Business Partner Ruteo import
  async handleBusinessPartnerRuteoImport(
    data: any[],
    metadata?: any
  ): Promise<any> {
    const fileName = metadata?.fileName || "business_partner_ruteo.xlsx";
    const sheetName =
      this?.businessPartnerRuteoImportConfig?.backendSheetName ||
      "Cliente-Territorio";

    try {
      const excelFile = await this.excelGeneratorService.generateExcelFile(
        data,
        this.businessPartnerRuteoImportConfig.columns,
        fileName,
        sheetName
      );

      // Create FormData to match the existing service expectation
      const formData = new FormData();

      // Add the generated Excel file (this is what the API expects)
      formData.append("file", excelFile, fileName);

      // Add the validated data as JSON for backend processing
      formData.append("validatedData", JSON.stringify(data));

      // Add metadata if available
      if (metadata) {
        formData.append("metadata", JSON.stringify(metadata));
      }

      // Call existing service method for Ruteo
      const response = (await this.subrouteService
        .importFile(formData)
        .toPromise()) as any;

      // Refresh data after successful import
      this.findAllWithCount();

      const processedResultData = response?.data?.result1;

      // Transform response to expected format
      return {
        success:
          processedResultData?.processResult?.errorCount === 0 ? true : false,
        data: processedResultData ||
          response?.data?.result1 || {
            processResult: {
              totalRecords: data.length,
              validRecords: data.length,
              invalidRecords: [],
              createdCount: data.length,
              errorCount: 0,
            },
          },
        message:
          response?.message || typeof response == "string"
            ? response
            : "Importación de ruteo completada exitosamente",
      };
    } catch (error) {
      this.handlerMessage.error({
        message: error?.error?.message,
        alternativeMessage: "Error en importación de Cliente teritorio",
        statusCode: error?.status,
      });
      throw error;
    }
  }

  // Custom handler for Business Partner Direcciones import
  async handleBusinessPartnerDireccionesImport(
    data: any[],
    metadata?: any
  ): Promise<any> {
    const fileName = metadata?.fileName || "business_partner_direcciones.xlsx";
    const sheetName =
      this?.businessPartnerDireccionesImportConfig?.backendSheetName ||
      "Direcciones de Socios de Negoci";

    try {
      const excelFile = await this.excelGeneratorService.generateExcelFile(
        data,
        this.businessPartnerDireccionesImportConfig.columns,
        fileName,
        sheetName
      );

      // Create FormData to match the existing service expectation
      const formData = new FormData();

      // Add the generated Excel file (this is what the API expects)
      formData.append("file", excelFile, fileName);

      // Add the validated data as JSON for backend processing
      formData.append("validatedData", JSON.stringify(data));

      // Add metadata if available
      if (metadata) {
        formData.append("metadata", JSON.stringify(metadata));
      }

      // Call existing service method for Direcciones
      const response = (await this.businessService
        .saveImportAddressFile(formData)
        .toPromise()) as any;

      // Refresh data after successful import
      this.findAllWithCount();

      // TODO: Remove this function when the backend is fixed to know how to return the processResult

      const processedResultData = response?.data?.result1;

      // Transform response to expected format
      return {
        success:
          processedResultData?.processResult?.errorCount === 0 ? true : false,
        data: processedResultData || {
          processResult: {
            totalRecords: data.length,
            validRecords: data.length,
            invalidRecords: [],
            createdCount: data.length,
            errorCount: 0,
          },
        },
        message:
          response?.message ||
          "Importación de direcciones completada exitosamente",
      };
    } catch (error) {
      this.handlerMessage.error({
        message: error?.error?.message,
        alternativeMessage: "Error en importación de direcciones",
        statusCode: error?.status,
      });
      throw error;
    }
  }

  // Custom handler for Cliente-Frecuencia import
  async handleClienteFrecuenciaImport(
    data: any[],
    metadata?: any
  ): Promise<any> {
    const fileName = metadata?.fileName || "cliente_frecuencia.xlsx";
    const sheetName =
      this?.clienteFrecuenciaImportConfig?.backendSheetName ||
      "Cliente-Frecuencia-Ruta";

    try {
      const columns = this.clienteFrecuenciaImportConfig.columns;

      const excelFile = await this.excelGeneratorService.generateExcelFile(
        data,
        columns,
        fileName,
        sheetName
      );

      // Create FormData to match the existing service expectation
      const formData = new FormData();

      // Add the generated Excel file (this is what the API expects)
      formData.append("file", excelFile, fileName);

      // Add the validated data as JSON for backend processing
      formData.append("validatedData", JSON.stringify(data));

      // Add metadata if available
      if (metadata) {
        formData.append("metadata", JSON.stringify(metadata));
      }

      const response = (await this.subrouteService
        .importFile(formData)
        .toPromise()) as any;

      this.findAllWithCount();

      const lookForProcessedResultObject = findByKey(response, "processResult");

      const processedResultData = response?.data?.result3;

      return {
        success:
          processedResultData?.processResult?.errorCount === 0 ? true : false,
        data: processedResultData ||
          lookForProcessedResultObject || {
            processResult: {
              totalRecords: data.length,
              validRecords: data.length,
              invalidRecords: [],
              createdCount: data.length,
              errorCount: 0,
            },
          },
        message:
          response?.message ||
          "Importación de direcciones completada exitosamente",
      };
    } catch (error) {
      this.handlerMessage.error({
        message: error?.error?.message,
        alternativeMessage: "Error en importación de Cliente-Frecuencia-Ruta",
        statusCode: error?.status,
      });
      throw error;
    }
  }

  //map
  isNew: boolean = true;

  constructor(
    // public exportService: ExportService,
    private readonly companyService: CompanyService,
    private readonly routeAreaService: RouteAreaService,
    private readonly routeService: RouteService,
    private readonly businessTypeService: BusinessPartnerTypeService,
    private readonly salesOfficeService: SalesOfficeService,
    private readonly businessGroupService: BusinessPartnerGroupService,
    private readonly paymentService: PaymentConditionService,
    private readonly businessService: BusinessPartnerService,
    private readonly businessPartnerChainService: BusinessPartnerDistributionService,
    private readonly businessContactService: BusinessPartnerContactService,
    private readonly phoneService: BusinessPartnerPhoneService,
    private readonly emailService: BusinessPartnerEmailService,
    private readonly interlocutorService: BusinessPartnerInterlocutorService,
    private readonly addressService: BusinessPartnerAddressService,
    private readonly orderDeliveryService: BusinessPartnerOrderService,
    private readonly businessSubGroupService: BusinessPartnerSubGroupService,
    private readonly requirementService: RequirementService,
    private readonly subrouteService: SubRouteService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private readonly handlerMessage: HandlerMessageService,
    private cdr: ChangeDetectorRef,
    private businessPartnerExport: BusinessPartnerExport,
    private businessPartnerAddressExport: BusinessPartnerAddressExport,
    private businessPartnerByOneAddressExport: BusinessPartnerByOneAddressExport,
    private materialGroupService: MaterialGroupService,
    private fb: FormBuilder,
    private excelGeneratorService: ExcelGeneratorService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private readonly companyFieldCatalogService: CompanyFieldCatalogService,
    private confirmationService: ConfirmationService
  ) {
    this.form = this.fb.group({
      companyId: [],
      businessPartnerRolId: [],
      businessPartnerTypeId: [],
      subRouteId: [],
    });
  }

  ngOnInit(): void {
    this.subs.push(
      this.activatedRoute.queryParams.subscribe((params) => {
        if (params["search"]) {
          this.searchService.setSearchTerm(params["search"]);
        }
      })
    );
  }

  ngAfterViewInit(): void {
    this.fetchAllCompanies();
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();

    this.companyMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCompanies();
      });
    this.typeMultiFilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy)) // Limpiar suscripción al destruir el componente
      .subscribe(() => {
        this.filterTypeMulti(); // Llamar a la función existente para filtrar
      });

    this.useGpsList = Object.entries(PermissionModeEnum)
      .filter(([key, value]) => typeof value === "number")
      .map(([key, value]) => ({
        key, // PERMISSIVE, RESTRICTIVE, ROUTE_BASED
        value: value as number, // 0,1,2
      }));
  }

  filterCompanies(): void {
    const search = this.companyMultiFilterCtrl.value?.toLowerCase() || "";
    const filtered = this.companyList.filter((company) =>
      company.name.toLowerCase().includes(search)
    );
    this.filteredCompany.next(filtered);
  }

  getDayNames(days: number[]): string {
    return days
      .map((day) => {
        const foundDay = this.daysList.find((d) => d.value === day);
        return foundDay ? foundDay.day : "";
      })
      .join(", ");
  }

  enableInterlocutorTab(distributionChain: any) {
    this.interlocutorsDataSource = [];
    this.currentDistributionChain = distributionChain;
    this.interlocutorsDataSource = distributionChain?.interlocutors || [];
    this.isInterlocutorTabEnabled = true;
    this.isInterlocutorTabVisible = true;
    this.selectedTabIndex = 2;
  }

  private initializeCreateBusinessPartner(): ICreateBusinessPartner {
    return {
      code: "",
      NIT: "",
      name: "",
      creditLimitEnabled: false,
      creditLimit: 0,
      creditAvailable: 0,
      allowOverdueInvoices: false,
      isTaxExempt: false,
      useGps: true,
      routeAreaId: "",
      businessPartnerGroupId: "",
      businessPartnerSubGroupId: "",
      paymentConditionId: "",
      routingSalesOfficeId: "",
      requirementIds: [],
      useGpsMode: PermissionModeEnum.ROUTE_BASED,
      distanceBtwSellerAndCustomer: 0,
      companyIds: [],
      typeIds: [],
    };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  private async fetchAllCompanies() {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;
        this.filteredCompany.next(this.companyList);
        this.companiesLoaded = true;

        this.filteredCompany.pipe(take(1)).subscribe((materials) => {
          const selectedMaterials = materials.filter((material) =>
            this.currentUpdateBusinessPartner?.companies
              .map((r) => r._id.toString())
              .includes(material._id.toString())
          );
          this.companyMultiCtrl.setValue(selectedMaterials);
        });

        // listen for search field value changes
        this.companyMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterCompMulti();
            this.setToggleAllCheckboxStateComp();
          });
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err?.error?.message,
          alternativeMessage: "Error al obtener compañías",
          statusCode: err?.status,
        });
      },
    });
  }

  protected filterCompMulti() {
    if (!this.companyList) {
      return;
    }
    // get the search keyword
    let search = this.companyMultiFilterCtrl.value;
    if (!search) {
      this.filteredCompanyCache = this.companyList;
      this.filteredCompany.next(this.companyList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredCompanyCache = this.companyList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredCompany.next(this.filteredCompanyCache);
  }

  toggleSelectAllCompany(selectAllValue: boolean) {
    this.filteredCompany
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.companyMultiCtrl.patchValue(val);
        } else {
          this.companyMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateComp() {
    let filteredLength = 0;
    if (this.companyMultiCtrl && this.companyMultiCtrl.value) {
      this.filteredCompanyCache.forEach((el) => {
        if (this.companyMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateComp =
        filteredLength > 0 && filteredLength < this.filteredCompanyCache.length;
      this.isCheckedComp =
        filteredLength > 0 &&
        filteredLength === this.filteredCompanyCache.length;
    }
  }

  private fetchAllPaymentCondition(): void {
    this.paymentService.findToComboBox().subscribe({
      next: (res) => {
        this.paymentConditionList = res.data;
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err?.error?.message,
          alternativeMessage: "Error al obtener condiciones de pago",
          statusCode: err?.status,
        });
      },
    });
  }

  private fetchAllRutas(): void {
    this.routeService.findToComboBox().subscribe({
      next: (res) => {
        this.rutaList = res.data;

        // CRITICAL FIX: Copy isPrincipal from business partner's routes to rutaList objects
        // This prevents race condition where fetchAllRutas() overwrites filteredRoutes with objects lacking isPrincipal
        if (this.currentUpdateBusinessPartner?.routes) {
          const businessPartnerRoutes =
            this.currentUpdateBusinessPartner.routes;
          this.rutaList.forEach((rutaItem) => {
            const matchingRoute = businessPartnerRoutes.find(
              (bpRoute) => bpRoute._id.toString() === rutaItem._id.toString()
            );
            if (matchingRoute) {
              (rutaItem as any).isPrincipal =
                matchingRoute.isPrincipal === true;
            }
          });
        }

        // FASE 1: Filtrar para mostrar SOLO las rutas asignadas al socio
        let availableRoutes = this.rutaList;

        // Si estamos en modo edición, filtrar solo las rutas del socio
        if (this.currentUpdateBusinessPartner?.routes) {
          const assignedRouteIds = this.currentUpdateBusinessPartner.routes.map(
            (r) => r._id.toString()
          );
          availableRoutes = this.rutaList.filter((route) =>
            assignedRouteIds.includes(route._id.toString())
          );
        }
        // Si estamos en modo creación, el socio no tiene rutas aún, mostrar array vacío
        else if (this.currentCreateBusinessPartner) {
          availableRoutes = [];
        }

        this.filteredRoutes.next(availableRoutes);

        this.filteredRoutes.pipe(take(1)).subscribe((materials) => {
          const selectedMaterials = materials.filter((material) =>
            this.currentUpdateBusinessPartner?.routes
              .map((r) => r._id.toString())
              .includes(material._id.toString())
          );
          this.routeMultiCtrl.setValue(selectedMaterials);
        });

        // listen for search field value changes
        this.routeMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterRouteMulti();
            this.setToggleAllCheckboxState();
          });
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err?.error?.message,
          alternativeMessage: "Error al obtener rutas",
          statusCode: err?.status,
        });
      },
    });
  }

  protected filterRouteMulti() {
    if (!this.rutaList) {
      return;
    }

    // CRITICAL FIX: Copy isPrincipal from business partner's routes to rutaList objects
    // This ensures search filtering preserves isPrincipal state
    if (this.currentUpdateBusinessPartner?.routes) {
      const businessPartnerRoutes = this.currentUpdateBusinessPartner.routes;
      this.rutaList.forEach((rutaItem) => {
        const matchingRoute = businessPartnerRoutes.find(
          (bpRoute) => bpRoute._id.toString() === rutaItem._id.toString()
        );
        if (matchingRoute) {
          (rutaItem as any).isPrincipal = matchingRoute.isPrincipal === true;
        }
      });
    }

    // FASE 1: Filtrar para mostrar SOLO las rutas asignadas al socio
    let availableRoutes = this.rutaList;

    // Si estamos en modo edición, filtrar solo las rutas del socio
    if (this.currentUpdateBusinessPartner?.routes) {
      const assignedRouteIds = this.currentUpdateBusinessPartner.routes.map(
        (r) => r._id.toString()
      );
      availableRoutes = this.rutaList.filter((route) =>
        assignedRouteIds.includes(route._id.toString())
      );
    }
    // Si estamos en modo creación, el socio no tiene rutas aún, mostrar array vacío
    else if (this.currentCreateBusinessPartner) {
      availableRoutes = [];
    }

    // get the search keyword
    let search = this.routeMultiFilterCtrl.value;
    if (!search) {
      this.filteredRouteCache = availableRoutes;
      this.filteredRoutes.next(availableRoutes);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredRouteCache = availableRoutes.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredRoutes.next(this.filteredRouteCache);
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredRoutes
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.routeMultiCtrl.patchValue(val);
        } else {
          this.routeMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxState() {
    let filteredLength = 0;
    if (this.routeMultiCtrl && this.routeMultiCtrl.value) {
      this.filteredRouteCache.forEach((el) => {
        if (this.routeMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate =
        filteredLength > 0 && filteredLength < this.filteredRouteCache.length;
      this.isChecked =
        filteredLength > 0 && filteredLength === this.filteredRouteCache.length;
    }
  }

  private fetchAllRequirement(): void {
    this.requirementService.findToComboBox().subscribe({
      next: (res) => {
        this.requirementList = res.data;
        this.filteredRequirement.next(this.requirementList);

        this.filteredRequirement.pipe(take(1)).subscribe((materials) => {
          const selectedMaterials = materials.filter((material) =>
            this.currentUpdateBusinessPartner?.requirements
              .map((r) => r._id.toString())
              .includes(material._id.toString())
          );
          this.requirementMultiCtrl.setValue(selectedMaterials);
        });

        // listen for search field value changes
        this.requirementMultiFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterRequirementMulti();
            this.setToggleAllCheckboxStateReq();
          });
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err?.error?.message,
          alternativeMessage: "Error al obtener requerimientos",
          statusCode: err?.status,
        });
      },
    });
  }

  protected filterRequirementMulti() {
    if (!this.requirementList) {
      return;
    }
    // get the search keyword
    let search = this.requirementMultiFilterCtrl.value;
    if (!search) {
      this.filteredRequirementCache = this.requirementList;
      this.filteredRequirement.next(this.requirementList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredRequirementCache = this.requirementList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      return nameMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredRequirement.next(this.filteredRequirementCache);
  }

  toggleSelectAllReq(selectAllValue: boolean) {
    this.filteredRequirement
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.requirementMultiCtrl.patchValue(val);
        } else {
          this.requirementMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateReq() {
    let filteredLength = 0;
    if (this.requirementMultiCtrl && this.requirementMultiCtrl.value) {
      this.filteredRequirementCache.forEach((el) => {
        if (this.requirementMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateReq =
        filteredLength > 0 &&
        filteredLength < this.filteredRequirementCache.length;
      this.isCheckedReq =
        filteredLength > 0 &&
        filteredLength === this.filteredRequirementCache.length;
    }
  }

  private fetchAllRouteArea(): void {
    this.routeAreaService.findToComboBox().subscribe({
      next: (res) => {
        this.routeAreaList = res.data;
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err?.error?.message,
          alternativeMessage: "Error al obtener áreas de ruta",
          statusCode: err?.status,
        });
      },
    });
  }

  private fetchAllSalesOffice(): void {
    this.salesOfficeService.findToComboBox().subscribe({
      next: (res) => {
        this.salesOfficeList = res.data;
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err?.error?.message,
          alternativeMessage: "Error al obtener oficinas de ventas",
          statusCode: err?.status,
        });
      },
    });
  }

  fetchAllBusinessGroup(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.businessGroupService.findToComboBox().subscribe({
        next: (res: IRequestResult<BusinessPartnerGroupAttributes[]>) => {
          this.businessGroupList = res.data;
          resolve();
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err?.error?.message,
            alternativeMessage: "Error al obtener grupos de socios de negocio",
            statusCode: err?.status,
          });
          reject(err);
        },
      });
    });
  }

  changeGroup(event): void {
    this.businessSubGroupList = [];
    let group = this.businessGroupList.find((ele) => ele._id == event);
    this.getComboBusinessSubGroup(group?.id);
  }

  getComboBusinessSubGroup(group): void {
    if (!group) {
      return;
    }

    this.businessSubGroupService.findToComboBox(group).subscribe({
      next: (res) => {
        this.businessSubGroupList = res.data;
        this.listFilterBusinessSubGroup = this.businessSubGroupList.slice();
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err?.error?.message,
          alternativeMessage: "Error al obtener subgrupos de socios de negocio",
          statusCode: err?.status,
        });
      },
    });
  }

  changueOptionsSubgroup(event) {
    if (!this.businessSubGroupList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listFilterBusinessSubGroup = this.businessSubGroupList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listFilterBusinessSubGroup = this.businessSubGroupList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  changeRol() {
    this.selectedTypeCodes = [];
    this.businessPartnerFilterTypeList = [];
    this.getFilterBusinessTypes();
  }

  toggleRole(role: string): void {
    // Si el rol ya está seleccionado, lo eliminamos
    if (this.selectedRol.includes(role)) {
      this.selectedRol = this.selectedRol.filter((r) => r !== role);
    } else {
      // Si no está seleccionado, lo agregamos
      this.selectedRol.push(role);
    }

    this.changeRol(); // Actualizamos los filtros
  }

  // private getFilterBusinessTypes(): void {
  //   let type = this.selectedRol ? (this.selectedRol == 'Em' ? '1' : (this.selectedRol == 'Ex' ? '0' : null) ) : null
  //   this.businessTypeService.findToComboBox(type).subscribe({
  //     next: (res) => {
  //       this.businessPartnerFilterTypeList = res.data;
  //     },
  //     error: (err) => {
  //     },
  //   });
  // }

  private getFilterBusinessTypes(): void {
    let type: string | null = null;

    if (this.selectedRol.includes("Em") && this.selectedRol.includes("Ex")) {
      type = null; // Filtrar por ambos
    } else if (this.selectedRol.includes("Em")) {
      type = "1"; // Filtrar solo por empleados
    } else if (this.selectedRol.includes("Ex")) {
      type = "0"; // Filtrar solo por externos
    }

    this.businessTypeService.findToComboBox(type).subscribe({
      next: (res) => {
        this.businessPartnerFilterTypeList = res.data;
        this.businessTypesFilterLoaded = true;
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err?.error?.message,
          alternativeMessage: "Error al obtener tipos de socios de negocios",
          statusCode: err?.status,
        });
      },
    });
  }

  private fetchAllBusinessTypes(): void {
    this.businessTypeService.findToComboBox().subscribe({
      next: (res) => {
        this.businessPartnerTypeList = res.data;
        this.filteredType.next(this.businessPartnerTypeList);

        if (this.currentUpdateBusinessPartner) {
          this.filteredType.pipe(take(1)).subscribe((materials) => {
            const selectedMaterials = materials.filter((material) =>
              this.currentUpdateBusinessPartner?.types
                .map((r) => r._id.toString())
                .includes(material._id.toString())
            );
            this.typeMultiCtrl.setValue(selectedMaterials);
            let type = this.typeMultiCtrl.value.some(
              (type: BusinessPartnerTypeAttributes) => type.code === "BPT0002"
            );
            if (type) {
              this.isSeller = true;
            }

            // Initialize isRtnRequired based on loaded types
            const currentCodes = this.typeMultiCtrl.value.map(
              (t: BusinessPartnerTypeAttributes) => t.code
            );
            this.isRtnRequired = !currentCodes.some((code) =>
              this.RTN_OPTIONAL_TYPES.includes(code as BusinessPartnerTypeEnum)
            );
          });

          // listen for search field value changes
          this.typeMultiFilterCtrl.valueChanges
            .pipe(takeUntil(this._onDestroy))
            .subscribe(() => {
              this.filterTypeMulti();
              this.setToggleAllCheckboxStateType();
            });
        }
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err?.error?.message,
          alternativeMessage: "Error al obtener tipos de socios de negocios",
          statusCode: err?.status,
        });
      },
    });
  }

  onTypeChange(event) {
    this.selectedOption = event.value.map((value) => value.code);
    if (
      Array.isArray(event.value) &&
      !event.value.some((type) => type.code === "BPT0002")
    ) {
      //vendedor
      this.isSeller = false;
    } else {
      this.isSeller = true;
    }

    // RTN is optional if there's Cliente Eventual (BPT9002) or Consumidor Final (BPT9001)
    this.isRtnRequired = !this.selectedOption.some((code) =>
      this.RTN_OPTIONAL_TYPES.includes(code as BusinessPartnerTypeEnum)
    );
  }
  isOptionDisabled(option: any): boolean {
    let blockedOptions = ["BPT9002", "BPT9001", "BPT0004"];

    const isBlockedOptionSelected = this.selectedOption.some((selected) =>
      blockedOptions.includes(selected)
    );

    if (isBlockedOptionSelected) {
      return option.code !== this.selectedOption[0];
    }
    return false;
  }

  protected filterTypeMulti() {
    if (!this.businessPartnerTypeList) {
      return;
    }
    // get the search keyword
    let search = this.typeMultiFilterCtrl.value;
    if (!search) {
      this.filteredTypeCache = this.businessPartnerTypeList;
      this.filteredType.next(this.businessPartnerTypeList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredTypeCache = this.businessPartnerTypeList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      return nameMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredType.next(this.filteredTypeCache);
  }

  toggleSelectAllType(selectAllValue: boolean) {
    this.filteredType
      .pipe(take(1), takeUntil(this._onDestroy))
      .subscribe((val) => {
        if (selectAllValue) {
          this.typeMultiCtrl.patchValue(val);
        } else {
          this.typeMultiCtrl.patchValue([]);
        }
      });
  }
  protected setToggleAllCheckboxStateType() {
    let filteredLength = 0;
    if (this.typeMultiCtrl && this.typeMultiCtrl.value) {
      this.filteredTypeCache.forEach((el) => {
        if (this.typeMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateType =
        filteredLength > 0 && filteredLength < this.filteredTypeCache.length;
      this.isCheckedType =
        filteredLength > 0 && filteredLength === this.filteredTypeCache.length;
    }
  }

  findAllWithCount(): void {
    // const pageIndex = this.paginator.pageIndex ;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" =
      this.sort.direction === "asc" ? "ASC" : "DESC";

    // const companyCodes = this.getSelectedCompanyCodes(this.selectedCompanyIds);
    let filter: IFilters = {
      companyId: this.form.get("companyId")?.value,
      businessPartnerRolId: this.form.get("businessPartnerRolId")?.value,
      typeCustomer: this.selectedCustomerType.length
        ? this.selectedCustomerType
        : null,
      subRouteId: this.form.get("subRouteId")?.value,
      status: this.selectedStatuses.length ? this.selectedStatuses : null,
    };

    this.businessService
      .findAllWithCount(
        {
          currentPage: this.pageIndex,
          limitPerPage: this.pageSize,
          search: this.searchQuery,
          sort: sortField,
          sortDirection: sortDirection,
        },
        false,
        [],
        this.geolocationFilter,
        filter
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof BusinessPartnerAttributes {
    const validSortFields: (keyof BusinessPartnerAttributes)[] = [
      "id",
      "name",
      "creditLimit",
      "position",
    ];
    return validSortFields.includes(
      this.sort.active as keyof BusinessPartnerAttributes
    )
      ? (this.sort.active as keyof BusinessPartnerAttributes)
      : "id";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      // this.paginator.pageIndex = 1 ;
      this.findAllWithCount();
    }
  }

  public onHandleSearch() {
    this.searchSubscription = this.searchService.searchTerm$.subscribe(
      (term) => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.findAllWithCount();
        }
      }
    );
  }

  filterByGeolocation(filterGeoLocation: "not_registered" | "valid" | "both") {
    this.geolocationFilter = filterGeoLocation;
    this.findAllWithCount();
  }

  trackByFn(index: number, item: BusinessPartnerAttributes): string {
    return item._id.toString();
  }

  // Método que se activa cuando se selecciona una nueva Compañía
  // onCompanySelectionChange(companyId: string): void {
  //   const selectedCompany = this.companyList.find(company => company._id.toString() === companyId);
  //   if (this.currentUpdateBusinessPartner && selectedCompany) {
  //     this.currentUpdateBusinessPartner.companies = selectedCompany;
  //   }
  // }

  openDistributionChainModal(existingData?: any) {
    const dialogRef = this.dialog.open(AddDistributionChainComponent, {
      panelClass: "form-modal",
      data: existingData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateBusinessPartnerChain(result);
        } else {
          this.createBusinessPartnerChain(result);
        }
      }
    });
  }

  openInterlocutorModal(existingData?) {
    const dialogRef = this.dialog.open(AddInterlocutorComponent, {
      panelClass: ".form-modal",
      data: existingData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateInterlocutor(result);
        } else {
          this.createInterlocutor(result);
        }
      }
    });
  }
  bp = "business-partner";
  openAddressModal(existingData?) {
    const dialogRef = this.dialog.open(AddBusinessPartnerAddressComponent, {
      panelClass: "form-modal",
      data: {
        ...existingData,
        bp: this.bp,
        bpId: this.currentUpdateBusinessPartner._id,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // Refresh entire business partner data including routes and addresses
        this.refreshBusinessPartnerData();
      }
    });
  }

  /** Refreshes business partner data after nested entity changes */
  private refreshBusinessPartnerData(): void {
    if (!this.currentUpdateBusinessPartner?._id) {
      console.warn("Cannot refresh: No business partner ID available");
      return;
    }

    this.businessService
      .findOne(this.currentUpdateBusinessPartner._id.toString())
      .pipe(takeUntil(this._onDestroy))
      .subscribe({
        next: (response) => {
          if (response?.data) {
            // Update all fields while preserving form control states
            this.currentUpdateBusinessPartner = {
              ...this.currentUpdateBusinessPartner,
              ...response.data,
              routes: response.data.routes,
              addresses: response.data.addresses,
            };

            // Update territories select with latest routes
            if (this.currentUpdateBusinessPartner.routes?.length > 0) {
              this.filteredRoutes.next(
                this.currentUpdateBusinessPartner.routes
              );
              this.routeMultiCtrl.setValue(
                this.currentUpdateBusinessPartner.routes
              );
            } else {
              this.filteredRoutes.next([]);
              this.routeMultiCtrl.setValue([]);
            }

            // Refresh address table pagination
            if (this.paginator) {
              this.paginator.length =
                this.currentUpdateBusinessPartner.addresses?.length || 0;
            }
          }
        },
        error: (error) => {
          console.error("Error refreshing business partner data:", error);
          this.handlerMessage.error({
            message: error?.error?.message,
            alternativeMessage:
              "Error al actualizar los datos del socio de negocio",
            statusCode: error?.status,
          });
        },
      });
  }

  /** Returns true if at least one territory is marked as principal */
  hasPrincipalTerritory(): boolean {
    const routes = this.routeMultiCtrl.value;
    if (!routes || routes.length === 0) {
      return false;
    }
    return routes.some((route) => route.isPrincipal === true);
  }

  /**
   * Gets the current principal territory, or null if none exists
   * @param excludeId Optional ID to exclude from search (used to avoid ngModel race conditions)
   */
  getCurrentPrincipal(excludeId?: string): ShortRouteAttributes | null {
    const routes = this.currentUpdateBusinessPartner.routes;
    if (!routes || routes.length === 0) {
      return null;
    }

    return routes.find((route) => route.isPrincipal === true) || null;
  }

  /** Gets the name of the principal territory for display in dialogs */
  getCurrentPrincipalName(): string {
    const principal = this.getCurrentPrincipal();
    return principal ? principal.name : "";
  }

  /** Handles principal territory toggle with confirmation dialogs */
  togglePrincipalTerritory(
    territory: ShortRouteAttributes,
    event: MatSlideToggleChange
  ): void {
    const newStateToSet = event.checked;
    const currentPrincipal = this.getCurrentPrincipal();

    // Case 1: Toggling ON when no principal exists - just set it
    if (newStateToSet && !currentPrincipal) {
      this.updatePrincipalTerritory(territory);
      return;
    }

    // always when there is already something toggled we want to revert it until it gets confimed
    event.source.checked = !newStateToSet;

    // Case 2: Toggling OFF (attempting to remove principal) - NOT ALLOWED
    // Note: currentPrincipal is null here because ngModel already updated isPrincipal to false
    // So we detect this case by checking if toggle is OFF and no principal exists anymore
    if (
      !newStateToSet &&
      territory._id.toString() === currentPrincipal?._id.toString()
    ) {
      // Show informative message - cannot unmark principal directly
      this.handlerMessage.warning({
        message:
          "No se puede desmarcar el territorio principal directamente. Para cambiarlo, marca otro territorio como principal y este se desmarcará automáticamente.",
        alternativeMessage: "No se puede desmarcar territorio principal",
      });

      // Revert toggle back to ON immediately (both visual and model state)
      event.source.checked = true; // Force toggle visual state to ON
      territory.isPrincipal = true; // Update model state

      // CRITICAL FIX: Sync model across ALL references (routeMultiCtrl, filteredRoutes, currentUpdateBusinessPartner.routes, rutaList)
      // This ensures getCurrentPrincipal() works correctly for subsequent actions
      this.updatePrincipalTerritory(territory);

      return;
    }

    // Case 3: Toggling ON when another principal exists (change principal)
    // CRITICAL FIX: Recalculate currentPrincipal excluding current territory to avoid ngModel race condition
    // When ngModel updates territory.isPrincipal=true BEFORE this handler runs, getCurrentPrincipal()
    // might return the same territory we're marking, causing the condition to fail

    if (
      newStateToSet &&
      currentPrincipal &&
      currentPrincipal._id !== territory._id
    ) {
      // Revert toggle to OFF immediately, BEFORE showing dialog
      // This prevents visual change until user confirms
      event.source.checked = false;
      territory.isPrincipal = false;
      this.cdr.detectChanges();

      this.confirmationService
        .confirm({
          title: "Cambiar Territorio Principal",
          description: `El territorio '<strong>${currentPrincipal.name}</strong>' ya está marcado como principal.<br><br>¿Desea cambiarlo a '<strong>${territory.name}</strong>'?`,
          type: ConfirmationModalType.WARNING,
          descriptionIcon: "swap_horiz",
          confirmButtonText: "Sí, cambiar",
          cancelButtonText: "Cancelar",
        })
        .subscribe((confirmed) => {
          if (confirmed) {
            // Update model for all routes (marks new as principal, unmarks old)
            this.updatePrincipalTerritory(territory);

            // Force visual state of NEW toggle to ON
            event.source.checked = true;

            // Force change detection to sync ALL toggles with updated model
            this.cdr.detectChanges();
          }
          // If cancelled, do nothing - toggle is already OFF
        });
    }
  }

  /** Updates principal flag across all routes, ensuring only one principal exists */
  private updatePrincipalTerritory(
    newPrincipal: ShortRouteAttributes | null
  ): void {
    const currentRoutes = this.routeMultiCtrl.value;
    if (!currentRoutes || currentRoutes.length === 0) {
      return;
    }

    // CRITICAL: Mutate existing objects instead of creating new ones to preserve references
    currentRoutes.forEach((r) => {
      r.isPrincipal = newPrincipal
        ? r._id.toString() === newPrincipal._id.toString()
        : false;
    });

    // Sync rutaList to maintain consistency across search/filter operations
    if (this.rutaList) {
      this.rutaList.forEach((rutaItem) => {
        const matchingRoute = currentRoutes.find(
          (r) => r._id.toString() === rutaItem._id.toString()
        );
        if (matchingRoute) {
          (rutaItem as any).isPrincipal = matchingRoute.isPrincipal;
        }
      });
    }

    // Trigger change detection to update the view
    this.cdr.detectChanges();

    // Sync filteredRoutes to show the updated state
    // CRITICAL: Use spread operator to emit new array reference
    // This forces Angular to detect the change and re-render ALL toggles with correct isPrincipal state
    this.filteredRoutes.next([...currentRoutes]);

    // Update component state (use same reference)
    this.currentUpdateBusinessPartner.routes = currentRoutes;
  }

  // createAddress(result): void {
  //   this.addressService
  //     .createEmbedded(this.currentUpdateBusinessPartner._id.toString(), result)
  //     .subscribe({
  //       next: () => {
  //         this.snackBar.open("Registro creado con éxito", "Cerrar", {
  //           duration: 3000,
  //         });
  //         this.addressService
  //           .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
  //           .subscribe((data) => {
  //             this.currentUpdateBusinessPartner.addresses = data?.data;
  //             this.paginator.length = this.totalItems;
  //           });
  //       },
  //       error: (err) => {
  //         this.snackBar.open(
  //           err.error.message || "Error al crear el registro",
  //           "Cerrar",
  //           { duration: 3000 }
  //         );
  //       },
  //     });
  // }

  // updateAddress(result): void {
  //   //fix con las fechas en el arreglo de telefonos
  //   result.phones =result.phones.forEach((phone: { type: any }) => {
  //     if (phone.type.createdAt) {
  //     phone.type.createdAt = new Date(phone.type.createdAt);
  //     }
  //     if (phone.type.updatedAt) {
  //     phone.type.updatedAt = new Date(phone.type.updatedAt);
  //     }
  //   });
  //       this.addressService
  //     .updateEmbedded(
  //       this.currentUpdateBusinessPartner._id.toString(),
  //       result._id.toString(),
  //       result
  //     )
  //     .subscribe({
  //       next: () => {
  //         this.snackBar.open("Registro actualizado con éxito", "Cerrar", {
  //           duration: 3000,
  //         });
  //         this.addressService
  //           .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
  //           .subscribe((data) => {
  //             this.currentUpdateBusinessPartner.addresses = data?.data;
  //             this.paginator.length = this.totalItems;
  //           });
  //       },
  //       error: (err) => {
  //         this.snackBar.open(
  //           err.error.message || "Error al actualizar el registro",
  //           "Cerrar",
  //           { duration: 3000 }
  //         );
  //       },
  //     });
  // }

  openOrderModal(existingData?) {
    const dialogRef = this.dialog.open(AddBusinessPartnerOrderComponent, {
      panelClass: ".form-modal-interlocutor",
      data: existingData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateOrder(result);
        } else {
          this.createOrder(result);
        }
      }
    });
  }
  createOrder(result): void {
    this.orderDeliveryService
      .createEmbedded(this.currentUpdateBusinessPartner._id.toString(), result)
      .subscribe({
        next: () => {
          this.handlerMessage.success({ message: "Registro creado con éxito" });
          this.orderDeliveryService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.orderDeliveryWindows =
                data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err?.error?.message,
            alternativeMessage: "Error al crear el registro",
            statusCode: err?.status,
          });
        },
      });
  }
  updateOrder(result): void {
    this.orderDeliveryService
      .updateEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.handlerMessage.success({
            message: "Registro actualizado con éxito",
          });
          this.orderDeliveryService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.orderDeliveryWindows =
                data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err?.error?.message,
            alternativeMessage: "Error al actualizar el registro",
            statusCode: err?.status,
          });
        },
      });
  }
  openEmailModal(existingData?) {
    const dialogRef = this.dialog.open(AddBusinessPartnerEmailComponent, {
      panelClass: "form-modal-interlocutor",
      data: existingData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateEmail(result);
        } else {
          this.createEmail(result);
        }
      }
    });
  }

  createEmail(result): void {
    this.emailService
      .createEmbedded(this.currentUpdateBusinessPartner._id.toString(), result)
      .subscribe({
        next: () => {
          this.handlerMessage.success({ message: "Registro creado con éxito" });
          this.emailService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.emails = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err?.error?.message,
            alternativeMessage: "Error al crear el registro",
            statusCode: err?.status,
          });
        },
      });
  }
  updateEmail(result): void {
    this.emailService
      .updateEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.handlerMessage.success({
            message: "Registro actualizado con éxito",
          });
          this.emailService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.emails = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err?.error?.message,
            alternativeMessage: "Error al actualizar el registro",
            statusCode: err?.status,
          });
        },
      });
  }
  openPhoneModal(existingData?) {
    const dialogRef = this.dialog.open(AddBusinessPartnerPhoneComponent, {
      data: existingData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updatePhone(result);
        } else {
          this.createPhone(result);
        }
      }
    });
  }

  createPhone(result): void {
    this.phoneService
      .createEmbedded(this.currentUpdateBusinessPartner._id.toString(), result)
      .subscribe({
        next: () => {
          this.handlerMessage.success({ message: "Registro creado con éxito" });
          this.phoneService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.phones = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err?.error?.message,
            alternativeMessage: "Error al crear el registro",
            statusCode: err?.status,
          });
        },
      });
  }

  updatePhone(result): void {
    this.phoneService
      .updateEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.handlerMessage.success({
            message: "Registro actualizado con éxito",
          });
          this.phoneService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.phones = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err?.error?.message,
            alternativeMessage: "Error al actualizar el registro",
            statusCode: err?.status,
          });
        },
      });
  }
  openContactModal(existingData?) {
    const dialogRef = this.dialog.open(AddBusinessPartnerContactComponent, {
      panelClass: "form-modal",
      data: existingData,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        if (existingData) {
          this.updateContact(result);
        } else {
          this.createContact(result);
        }
      }
    });
  }

  createContact(result): void {
    this.businessContactService
      .createEmbedded(this.currentUpdateBusinessPartner._id.toString(), result)
      .subscribe({
        next: () => {
          this.handlerMessage.success({ message: "Registro creado con éxito" });
          this.businessContactService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.contacts = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err?.error?.message,
            alternativeMessage: "Error al crear el registro",
            statusCode: err?.status,
          });
        },
      });
  }

  updateContact(result): void {
    this.businessContactService
      .updateEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.handlerMessage.success({ message: "Registro creado con éxito" });
          this.businessContactService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.contacts = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err?.error?.message,
            alternativeMessage: "Error al crear el registro",
            statusCode: err?.status,
          });
        },
      });
  }

  createInterlocutor(result): void {
    this.interlocutorService
      .createEmbedded2d(
        this.currentUpdateBusinessPartner._id.toString(),
        this.currentDistributionChain._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.handlerMessage.success({ message: "Registro creado con éxito" });
          this.interlocutorService
            .findByBusinessId(
              this.currentUpdateBusinessPartner._id.toString(),
              this.currentDistributionChain._id.toString()
            )
            .subscribe((data) => {
              this.interlocutorsDataSource = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err?.error?.message,
            alternativeMessage: "Error al crear el registro",
            statusCode: err?.status,
          });
        },
      });
  }

  updateInterlocutor(result): void {
    this.interlocutorService
      .updateEmbedded2d(
        this.currentUpdateBusinessPartner._id.toString(),
        this.currentDistributionChain._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.handlerMessage.success({
            message: "Registro actualizado con éxito",
          });
          this.interlocutorService
            .findByBusinessId(
              this.currentUpdateBusinessPartner._id.toString(),
              this.currentDistributionChain._id.toString()
            )
            .subscribe((data) => {
              this.interlocutorsDataSource = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err?.error?.message,
            alternativeMessage: "Error al actualizar el registro",
            statusCode: err?.status,
          });
        },
      });
  }

  private ensureCompaniesLoaded(): void {
    if (!this.companiesLoaded) {
      this.fetchAllCompanies();
    }
  }

  private ensureBusinessTypesFilterLoaded(): void {
    if (!this.businessTypesFilterLoaded) {
      this.getFilterBusinessTypes();
    }
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    this.ensureCompaniesLoaded();
    this.ensureBusinessTypesFilterLoaded();
  }

  private async ensureModalDataLoaded(): Promise<void> {
    if (!this.modalDataLoaded) {
      await this.initializeComboBox();
      this.fetchCategories();
      this.modalDataLoaded = true;
    }
  }

  async initializeComboBox() {
    this.fetchAllPaymentCondition();
    this.fetchAllRouteArea();
    this.fetchAllSalesOffice();
    await this.fetchAllBusinessGroup();
    this.fetchAllBusinessTypes();
    await this.fetchAllCompanies();
    this.fetchAllRutas();
    this.fetchAllRequirement();
  }

  async openCreateModal(): Promise<void> {
    this.currentUpdateBusinessPartner = null;
    await this.ensureModalDataLoaded();
    this.currentCreateBusinessPartner = this.initializeCreateBusinessPartner();
    this.dialogRefAdd = this.dialog.open(this.addModal, {
      panelClass: "form-modal",
      disableClose: true,
    });
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createBusinessPartner());
    this.dialogRefAdd.afterClosed().subscribe((result) => {
      result;
    });
  }

  async openEditModal(
    businessPartner: BusinessPartnerAttributes
  ): Promise<void> {
    this.selectedTabIndex = 0;
    await this.ensureModalDataLoaded();
    this.isInterlocutorTabVisible = false;
    const selectedCompany = businessPartner.companies
      ? this.companyList.find((company) =>
          businessPartner.companies.some((c) => c._id && c._id === company._id)
        )
      : null;

    const selectedRouteArea = businessPartner.routeArea?._id
      ? this.routeAreaList.find(
          (routeArea) => routeArea._id === businessPartner.routeArea._id
        )
      : null;
    const selectedPaymentCondition = businessPartner.paymentCondition?._id
      ? this.paymentConditionList.find(
          (payment) => payment._id === businessPartner.paymentCondition._id
        )
      : null;

    const selectedBusinessGroup = businessPartner.businessPartnerGroup?._id
      ? this.businessGroupList.find(
          (group) => group._id === businessPartner.businessPartnerGroup._id
        )
      : null;

    const selectedSales = businessPartner.routingSalesOffice?._id
      ? this.salesOfficeList.find(
          (sales) => sales._id === businessPartner.routingSalesOffice._id
        )
      : null;

    const selectedBusinessTypes = businessPartner.types
      ? this.businessPartnerTypeList.find((type) =>
          businessPartner.types.some((c) => c._id && c._id === type._id)
        )
      : null;
    this.currentUpdateBusinessPartner = {
      ...businessPartner,
      externalKeys: {
        code: businessPartner?.externalKeys?.code ?? null,
      },
      routeArea: selectedRouteArea || businessPartner.routeArea,
      paymentCondition:
        selectedPaymentCondition || businessPartner.paymentCondition,
      businessPartnerGroup:
        selectedBusinessGroup || businessPartner.businessPartnerGroup,
      routingSalesOffice: selectedSales || businessPartner.routingSalesOffice,
      companies: selectedCompany
        ? [...businessPartner.companies, selectedCompany]
        : businessPartner.companies,
      routes: businessPartner.routes, // Use routes directly from the API response
      types: selectedBusinessTypes
        ? [...businessPartner.types, selectedBusinessTypes]
        : businessPartner.types,
      businessPartnerSubGroup: businessPartner.businessPartnerSubGroup || null,
    };

    if (this.currentUpdateBusinessPartner.businessPartnerGroup) {
      this.changeGroup(
        this.currentUpdateBusinessPartner.businessPartnerGroup._id
      );
    }

    if (this.currentUpdateBusinessPartner.routes?.length > 0) {
      // CRITICAL: Mutate existing route objects to preserve references for ngModel binding
      this.currentUpdateBusinessPartner.routes.forEach((route) => {
        route.isPrincipal = route.isPrincipal === true;
      });

      // Use the SAME array reference for both to maintain object identity
      const routes = this.currentUpdateBusinessPartner.routes;

      this.filteredRoutes.next(routes);
      this.routeMultiCtrl.setValue(routes);

      // Force change detection to ensure toggles render with correct state
      this.cdr.detectChanges();
    } else {
      // If no routes, clear the select
      this.filteredRoutes.next([]);
      this.routeMultiCtrl.setValue([]);
    }

    // this.loadFieldsMasterData();

    // Initialize isRtnRequired based on business partner types BEFORE opening modal
    if (businessPartner.types && businessPartner.types.length > 0) {
      const typeCodes = businessPartner.types.map((t) => t.code);
      this.isRtnRequired = !typeCodes.some((code) =>
        this.RTN_OPTIONAL_TYPES.includes(code as BusinessPartnerTypeEnum)
      );
    } else {
      this.isRtnRequired = true; // Default to required if no types
    }

    this.dialogRefEdit = this.dialog.open(this.editModal, {
      panelClass: "form-modal",
      disableClose: true,
    });
    // this.dialogRefEdit.afterClosed().subscribe((result) =>result && this.updateBusinessPartner(businessPartner._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => {
      result;
    });
  }

  loadFieldsMasterData(): void {
    this.companyFieldCatalogService
      .getFieldsMaster(
        this.companyList[0]._id.toString(),
        UserFieldEntityTypeEnum.BUSINESS_PARTNER
      )
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.fieldsMasterDataStatus = res.data.statusId;
          this.fieldsMasterData = res.data.fields;
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err?.error?.message,
            alternativeMessage: "Error al obtener datos maestros de campos",
            statusCode: err?.status,
          });
        },
      });
  }

  isNotEmployee(): boolean {
    return !this.currentUpdateBusinessPartner.types.some((t) => t.isEmployee);
  }

  createBusinessPartner(): void {
    this.currentCreateBusinessPartner.typeIds = this.typeMultiCtrl.value.map(
      (type: BusinessPartnerTypeAttributes) => type._id.toString()
    );
    // Los territorios se asignarán automáticamente por el backend según las direcciones
    // this.currentCreateBusinessPartner.routeIds = this.routeMultiCtrl.value.map(
    //   (rou: RouteAttributes) => rou._id.toString()
    // );
    this.currentCreateBusinessPartner.companyIds =
      this.companyMultiCtrl.value.map((company: CompanyAttributes) =>
        company._id.toString()
      );
    this.currentCreateBusinessPartner.requirementIds =
      this.requirementMultiCtrl.value.map((req: RequirementAttributes) =>
        req._id.toString()
      );
    const dataToSend: Partial<ICreateBusinessPartner> = Object.entries(
      this.currentCreateBusinessPartner
    ).reduce((acc, [key, value]) => {
      if (value !== "" && !(Array.isArray(value) && value.length === 0)) {
        acc[key] = value;
      }
      return acc;
    }, {});
    this.businessService.create(dataToSend).subscribe({
      next: () => {
        this.handlerMessage.success({ message: "Registro creado con éxito" });
        this.findAllWithCount();
        this.dialogRefAdd.close();
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err?.error?.message,
          alternativeMessage: "Error al crear el registro",
          statusCode: err?.status,
        });
      },
    });
  }

  createBusinessPartnerChain(result): void {
    this.businessPartnerChainService
      .createEmbedded(this.currentUpdateBusinessPartner._id.toString(), result)
      .subscribe({
        next: () => {
          this.handlerMessage.success({ message: "Registro creado con éxito" });
          this.businessPartnerChainService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.distributionChains = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err?.error?.message,
            alternativeMessage: "Error al crear el registro",
            statusCode: err?.status,
          });
        },
      });
  }
  updateBusinessPartnerChain(result): void {
    this.businessPartnerChainService
      .updateEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        result._id.toString(),
        result
      )
      .subscribe({
        next: () => {
          this.handlerMessage.success({ message: "Registro creado con éxito" });
          this.businessPartnerChainService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.distributionChains = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err?.error?.message,
            alternativeMessage: "Error al crear el registro",
            statusCode: err?.status,
          });
        },
      });
  }

  updateBusinessPartner(id: string): void {
    if (this.currentUpdateBusinessPartner) {
      // FASE 1: Validación de territorio eliminada - ahora se gestiona desde direcciones
      if (
        !this.isSeller &&
        !this.currentUpdateBusinessPartner.businessPartnerGroup
        // !this.currentUpdateBusinessPartner.businessPartnerSubGroup
      ) {
        this.handlerMessage.warning({
          message: "Debe seleccionar grupo de socio",
        });
        return;
      }

      const updatedBusinessPartner: IUpdateBusinessPartner = {
        ...this.currentUpdateBusinessPartner,
        routeAreaId: this.currentUpdateBusinessPartner?.routeArea?._id
          ? this.currentUpdateBusinessPartner.routeArea._id.toString()
          : undefined,
        businessPartnerGroupId:
          this.currentUpdateBusinessPartner.businessPartnerGroup?._id?.toString() ||
          undefined,
        businessPartnerSubGroupId:
          this.currentUpdateBusinessPartner.businessPartnerSubGroup?._id.toString() ||
          undefined,
        paymentConditionId:
          this.currentUpdateBusinessPartner.paymentCondition?._id?.toString() ||
          undefined,
        routingSalesOfficeId:
          this.currentUpdateBusinessPartner.routingSalesOffice?._id?.toString() ||
          undefined,
        companyIds:
          this.companyMultiCtrl.value
            ?.map((company: CompanyAttributes) => company._id?.toString())
            .filter(Boolean) || [],
        typeIds:
          this.typeMultiCtrl.value
            ?.map((type: BusinessPartnerTypeAttributes) => type._id?.toString())
            .filter(Boolean) || [],
        // Include routes array with isPrincipal flags for principal territory feature
        routeIds:
          this.routeMultiCtrl.value
            ?.map((route: ShortRouteAttributes) => ({
              id: route._id?.toString(),
              isPrincipal: route.isPrincipal || false,
            }))
            .filter((r) => r.id) || [],
        routes:
          this.routeMultiCtrl.value
            ?.map((route: ShortRouteAttributes) => ({
              id: route._id?.toString(),
              isPrincipal: route.isPrincipal || false,
            }))
            .filter((r) => r.id) || [],
        requirementIds:
          this.requirementMultiCtrl.value
            ?.map((req: RequirementAttributes) => req._id?.toString())
            .filter(Boolean) || [],
      };

      // Validate principal territory before save
      if (
        this.routeMultiCtrl.value.length > 0 &&
        !this.hasPrincipalTerritory()
      ) {
        this.confirmationService
          .confirm({
            title: "Sin Territorio Principal",
            description:
              'El socio de negocio tiene territorios asignados pero <strong>ninguno está marcado como principal</strong>.<br><br>¿Desea continuar sin territorio principal?<br><br><span class="text-sm text-orange-600">Recomendación: Asigne un territorio principal antes de guardar.</span>',
            type: ConfirmationModalType.WARNING,
            descriptionIcon: "warning",
            confirmButtonText: "Sí, guardar sin principal",
            cancelButtonText: "No, volver a editar",
          })
          .subscribe((confirmed) => {
            if (confirmed) {
              this.performBusinessPartnerUpdate(id, updatedBusinessPartner);
            }
          });
        return;
      }

      // Proceed with save if validation passes
      this.performBusinessPartnerUpdate(id, updatedBusinessPartner);
    }
  }

  /** Performs the business partner update API call */
  private performBusinessPartnerUpdate(
    id: string,
    updatedBusinessPartner: IUpdateBusinessPartner
  ): void {
    this.businessService.update(id, updatedBusinessPartner).subscribe({
      next: () => {
        this.handlerMessage.success({
          message: "Registro actualizado con éxito",
        });
        this.findAllWithCount();
        this.dialogRefEdit.close();
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err?.error?.message,
          alternativeMessage: "Error al actualizar el registro",
          statusCode: err?.status,
        });
      },
    });
  }

  onStatusChange(
    event: boolean,
    businessPartner: BusinessPartnerAttributes
  ): void {
    const originalStatusId = businessPartner.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBusinessPartnerStatus: any = {
      name: businessPartner.name,
      statusId: updatedStatusId,
    };
    this.businessService
      .update(businessPartner._id.toString(), updatedBusinessPartnerStatus)
      .subscribe({
        next: () => {
          this.findAllWithCount();
        },
        error: () => {
          businessPartner.statusId = originalStatusId; // Volver al estado original si falla
          this.handlerMessage.error({
            message: "Error al actualizar el estado",
          });
          this.findAllWithCount();
        },
      });
  }

  onStatusChangeChain(event: boolean, item: any): void {
    const originalStatusId = item.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBusinessPartnerChain = { ...item, statusId: updatedStatusId };

    this.businessPartnerChainService
      .updateEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        item._id.toString(),
        updatedBusinessPartnerChain
      )
      .subscribe({
        next: () => {
          this.businessPartnerChainService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.distributionChains = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: () => {
          item.statusId = originalStatusId;
          this.handlerMessage.error({
            message: "Error al actualizar el estado",
          });
          this.businessPartnerChainService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.distributionChains = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
      });
  }

  onStatusChangeContact(event: boolean, item: any): void {
    const originalStatusId = item.contact.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBusinessPartnerContact = {
      ...item,
      contact: {
        ...item.contact,
        statusId: updatedStatusId,
      },
    };
    // this.businessContactService.updateEmbedded(this.currentUpdateBusinessPartner._id.toString(),item._id.toString(), updatedBusinessPartnerContact).subscribe({
    //   next: () => {
    //     this.businessContactService
    //     .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
    //     .subscribe((data) => {
    //       this.currentUpdateBusinessPartner.contacts = data?.data;
    //       this.paginator.length = this.totalItems;
    //     });
    //   },
    //   error: () => {
    //     item.contact.statusId = originalStatusId;
    //     this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
    //     this.businessContactService
    //     .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
    //     .subscribe((data) => {
    //       this.currentUpdateBusinessPartner.contacts = data?.data;
    //       this.paginator.length = this.totalItems;
    //     });
    //   }
    // });
  }

  onStatusChangePhone(event: boolean, item: any): void {
    const originalStatusId = item.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBusinessPartnerPhone = {
      ...item,
      statusId: updatedStatusId,
    };
    this.phoneService
      .updateEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        item._id.toString(),
        updatedBusinessPartnerPhone
      )
      .subscribe({
        next: () => {
          this.phoneService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.phones = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: () => {
          item.statusId = originalStatusId;
          this.handlerMessage.error({
            message: "Error al actualizar el estado",
          });
          this.phoneService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.phones = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
      });
  }

  onStatusChangeOrder(event: boolean, item: any): void {
    const originalStatusId = item.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBusinessPartnerOrder = {
      ...item,
      statusId: updatedStatusId,
    };
    this.orderDeliveryService
      .updateEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        item._id.toString(),
        updatedBusinessPartnerOrder
      )
      .subscribe({
        next: () => {
          this.orderDeliveryService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.orderDeliveryWindows =
                data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: () => {
          item.statusId = originalStatusId;
          this.handlerMessage.error({
            message: "Error al actualizar el estado",
          });
          this.orderDeliveryService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.orderDeliveryWindows =
                data?.data;
              this.paginator.length = this.totalItems;
            });
        },
      });
  }

  onStatusChangeEmail(event: boolean, item: any): void {
    const originalStatusId = item.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBusinessPartnerEmail = {
      ...item,
      statusId: updatedStatusId,
    };
    this.emailService
      .updateEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        item._id.toString(),
        updatedBusinessPartnerEmail
      )
      .subscribe({
        next: () => {
          this.emailService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.emails = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: () => {
          item.statusId = originalStatusId;
          this.handlerMessage.error({
            message: "Error al actualizar el estado",
          });
          this.emailService
            .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
            .subscribe((data) => {
              this.currentUpdateBusinessPartner.emails = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
      });
  }

  /** Handles address status change and warns if principal territory is removed */
  onStatusChangeAddress(event: boolean, item: any): void {
    const originalStatusId = item.statusId;
    const updatedStatusId = event ? 1 : 0;
    const wasDeactivated = updatedStatusId === 0;
    const hadPrincipalBeforeChange = this.hasPrincipalTerritory();

    const updatedBusinessPartnerAddress = {
      ...item,
      statusId: updatedStatusId,
    };

    this.addressService
      .updateEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        item._id.toString(),
        updatedBusinessPartnerAddress
      )
      .pipe(
        switchMap(() =>
          this.businessService.findOne(
            this.currentUpdateBusinessPartner._id.toString()
          )
        ),
        takeUntil(this._onDestroy)
      )
      .subscribe({
        next: (response) => {
          if (response?.data) {
            this.currentUpdateBusinessPartner = {
              ...this.currentUpdateBusinessPartner,
              ...response.data,
              routes: response.data.routes,
              addresses: response.data.addresses,
            };

            if (this.currentUpdateBusinessPartner.routes?.length > 0) {
              this.filteredRoutes.next(
                this.currentUpdateBusinessPartner.routes
              );
              this.routeMultiCtrl.setValue(
                this.currentUpdateBusinessPartner.routes
              );
            } else {
              this.filteredRoutes.next([]);
              this.routeMultiCtrl.setValue([]);
            }

            if (this.paginator) {
              this.paginator.length =
                this.currentUpdateBusinessPartner.addresses?.length || 0;
            }

            if (
              wasDeactivated &&
              hadPrincipalBeforeChange &&
              !this.hasPrincipalTerritory() &&
              this.routeMultiCtrl.value.length > 0
            ) {
              this.handlerMessage.warning({
                message:
                  "El territorio principal ha sido eliminado. Por favor, seleccione un nuevo territorio principal desde la pestaña de datos generales.",
              });
            }
          }
        },
        error: () => {
          item.statusId = originalStatusId;
          this.handlerMessage.error({
            message: "Error al actualizar el estado",
          });
        },
      });
  }

  onUpdateGeo(event: boolean, item: any): void {
    const originalGeoPoint = item.geolocationPointUpdate;
    if (
      event &&
      (!this.currentUpdateBusinessPartner.subRouteThereAreFrequencies ||
        this.currentUpdateBusinessPartner.subRouteThereAreFrequencies.length ===
          0)
    ) {
      this.handlerMessage.warning({
        message: "No hay frecuencias disponibles para activar",
      });
      setTimeout(() => {
        item.geolocationPointUpdate = originalGeoPoint;
      }, 0);
      return;
    }

    if (
      event &&
      this.currentUpdateBusinessPartner.subRouteThereAreFrequencies.length > 0
    ) {
      item.geolocationPointUpdate = true;

      const dialogRef = this.dialog.open<
        BusinesPartnerGeoDialogComponent,
        BusinesPartnerGeoDialogComponent["data"],
        BusinesPartnerGeoDialogComponent["selectedSubRoute"]
      >(BusinesPartnerGeoDialogComponent, {
        width: "500px",
        data: {
          subSroutes:
            this.currentUpdateBusinessPartner.subRouteThereAreFrequencies,
          subSroute: null,
        },
      });

      dialogRef.afterClosed().subscribe((selectedSubRoute) => {
        if (selectedSubRoute) {
          this.performUpdate(item, true, selectedSubRoute);
        } else {
          setTimeout(() => {
            item.geolocationPointUpdate = originalGeoPoint;
          }, 0);
        }
        this.selectedSubRoute = null;
      });
    } else {
      this.performUpdate(item, false);
    }
  }

  private performUpdate(
    item: any,
    geolocationPointUpdate: boolean,
    selectedSubRoute?: ShortSubRouteAttributes
  ): void {
    if (this.isUpdating) return;
    this.isUpdating = true;
    const originalGeoPoint = item.geolocationPointUpdate;

    const updateDataForAddress: any = {
      geolocationPointUpdate,
    };

    this.addressService
      .updateEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        item._id.toString(),
        { ...item, ...updateDataForAddress }
      )
      .subscribe({
        next: () => {
          if (geolocationPointUpdate && selectedSubRoute) {
            const updatedBusinessPartner: IUpdateBusinessPartner = {
              subRouteGeoUpdatePending: [
                {
                  ...selectedSubRoute,
                  date: new Date().toISOString(),
                },
              ],
            };

            this.businessService
              .updateGeo(
                this.currentUpdateBusinessPartner._id.toString(),
                item._id.toString(),
                updatedBusinessPartner
              )
              .subscribe({
                next: () => {
                  this.handlerMessage.success({
                    message: "Registro actualizado con éxito",
                  });
                },
                error: (err) => {
                  this.handlerMessage.error({
                    message: err?.error?.message,
                    alternativeMessage: "Error al actualizar el registro",
                    statusCode: err?.status,
                  });
                },
              });
          } else {
            const updatedBusinessPartner: any = {
              geolocationPointUpdate: geolocationPointUpdate,
            };
            this.businessService
              .updateAddressGeoStatus(
                this.currentUpdateBusinessPartner.externalKeys.code,
                item._id.toString(),
                updatedBusinessPartner
              )
              .subscribe({
                next: () => {
                  this.handlerMessage.success({
                    message: "Registro actualizado con éxito",
                  });
                },
                error: (err) => {
                  this.handlerMessage.error({
                    message: err?.error?.message,
                    alternativeMessage: "Error al actualizar el registro",
                    statusCode: err?.status,
                  });
                },
              });
          }
        },
        complete: () => {
          this.isUpdating = false;
          this.refreshAddressList();
        },
        error: () => {
          item.geolocationPointUpdate = originalGeoPoint;
          this.handlerMessage.error({
            message: "Error al actualizar el estado",
          });
        },
      });
  }

  private refreshAddressList(): void {
    this.addressService
      .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
      .subscribe((data) => {
        this.currentUpdateBusinessPartner.addresses = data?.data;
        this.paginator.length = this.totalItems;
      });
  }

  onStatusChangeInterlocutor(event: boolean, item: any): void {
    const originalStatusId = item.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedBusinessPartnerInterlocutor = {
      ...item,
      statusId: updatedStatusId,
    };

    this.interlocutorService
      .updateEmbedded2d(
        this.currentUpdateBusinessPartner._id.toString(),
        this.currentDistributionChain._id.toString(),
        item._id.toString(),
        updatedBusinessPartnerInterlocutor
      )
      .subscribe({
        next: () => {
          this.interlocutorService
            .findByBusinessId(
              this.currentUpdateBusinessPartner._id.toString(),
              this.currentDistributionChain._id.toString()
            )
            .subscribe((data) => {
              this.interlocutorsDataSource = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
        error: () => {
          item.statusId = originalStatusId;
          this.handlerMessage.error({
            message: "Error al actualizar el estado",
          });
          this.interlocutorService
            .findByBusinessId(
              this.currentUpdateBusinessPartner._id.toString(),
              this.currentDistributionChain._id.toString()
            )
            .subscribe((data) => {
              this.interlocutorsDataSource = data?.data;
              this.paginator.length = this.totalItems;
            });
        },
      });
  }

  isAllow(businessPartner: BusinessPartnerAttributes) {
    return businessPartner?.types?.some((type) => type.allowUserCreation);
  }

  openSettingUser(businessPartner: BusinessPartnerAttributes) {
    const dialogRef = this.dialog.open(SettingUserComponent, {
      data: businessPartner,
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === undefined || result == "Cancel") {
      } else {
        if (result == "success") {
        }
      }
    });
  }

  openDeleteDialog(materialGroup: BusinessPartnerAttributes): void {
    this.dialog
      .open(this.deleteDialog, {
        data: materialGroup,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe(
        (result) => result && this.delete(materialGroup._id.toString())
      );
  }

  openDeleteInterlocutor(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteInterlocutor(item));
  }

  deleteInterlocutor(item: any): void {
    this.interlocutorService
      .deleteEmbedded2d(
        this.currentUpdateBusinessPartner._id.toString(),
        this.currentDistributionChain._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.handlerMessage.success({
          message: "Interlocutor eliminado con éxito",
        });
        this.interlocutorService
          .findByBusinessId(
            this.currentUpdateBusinessPartner._id.toString(),
            this.currentDistributionChain._id.toString()
          )
          .subscribe((data) => {
            this.interlocutorsDataSource = data?.data;
            this.paginator.length = this.totalItems;
          });
      });
  }
  openDeleteContact(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteContact(item));
  }

  deleteContact(item: any): void {
    this.businessContactService
      .deleteEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.handlerMessage.success({
          message: "Contacto eliminado con éxito",
        });
        this.businessContactService
          .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
          .subscribe((data) => {
            this.currentUpdateBusinessPartner.contacts = data?.data;
            this.paginator.length = this.totalItems;
          });
      });
  }

  /**
   * Checks if deleting an address would remove the last occurrence of the principal territory
   * @returns Object with isLast flag and territory name if applicable
   */
  private isLastAddressWithPrincipalTerritory(addressToDelete: any): {
    isLast: boolean;
    territoryName: string | null;
  } {
    // Get the principal route from business partner
    const principalRoute = this.currentUpdateBusinessPartner?.routes?.find(
      (route) => route.isPrincipal === true
    );

    if (!principalRoute) {
      return { isLast: false, territoryName: null };
    }

    // Check if the address to delete has the principal route
    const addressHasPrincipalRoute = addressToDelete.routes?.some(
      (r: any) => r._id.toString() === principalRoute._id.toString()
    );

    if (!addressHasPrincipalRoute) {
      return { isLast: false, territoryName: null };
    }

    // Count how many addresses have the principal route
    const addressesWithPrincipalRoute =
      this.currentUpdateBusinessPartner?.addresses?.filter((addr) =>
        addr.routes?.some(
          (r: any) => r._id.toString() === principalRoute._id.toString()
        )
      ) || [];

    // If only ONE address has the principal route, this is the last one
    return {
      isLast: addressesWithPrincipalRoute.length === 1,
      territoryName: principalRoute.name,
    };
  }

  openDeleteAddress(item: any): void {
    // Check if this is the last address with the principal territory
    const { isLast, territoryName } =
      this.isLastAddressWithPrincipalTerritory(item);

    if (isLast) {
      // Show special warning confirmation about losing principal territory
      this.confirmationService
        .confirm({
          title: "Eliminar Dirección",
          description: `⚠️ <strong>Advertencia:</strong> Esta es la última dirección que contiene el territorio principal '<strong>${territoryName}</strong>'.<br><br>Al eliminar esta dirección, el socio de negocio quedará sin territorio principal asignado.<br><br>¿Está seguro de que desea continuar?`,
          type: ConfirmationModalType.WARNING,
          descriptionIcon: "warning",
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar",
        })
        .subscribe((confirmed) => {
          if (confirmed) {
            this.deleteAddress(item);
          }
        });
    } else {
      // Use normal delete confirmation dialog
      this.dialog
        .open(DeleteConfirmationComponent, {
          data: item,
          panelClass: "delete-modal",
          disableClose: true,
        })
        .afterClosed()
        .subscribe((result) => result && this.deleteAddress(item));
    }
  }

  /**
   * Deletes an address from the business partner
   *
   * When an address is deleted, the backend automatically removes its associated
   * territory from the business partner's routes array. If that territory was marked
   * as principal, this creates an edge case where the BP is left without a principal
   * territory.
   *
   * @param item - Address object to delete
   *
   * @remarks
   * - Backend automatically removes territory when address is deleted
   * - Checks if the removed territory was principal and shows warning
   * - Refreshes entire BP data to reflect backend changes
   *
   * @see refreshBusinessPartnerData
   */
  deleteAddress(item: any): void {
    const hadPrincipalBeforeDeletion = this.hasPrincipalTerritory();

    this.addressService
      .deleteEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        item._id.toString(),
        item
      )
      .pipe(
        switchMap(() =>
          this.businessService.findOne(
            this.currentUpdateBusinessPartner._id.toString()
          )
        ),
        takeUntil(this._onDestroy)
      )
      .subscribe({
        next: (response) => {
          this.handlerMessage.success({
            message: "Dirección eliminada con éxito",
          });

          if (response?.data) {
            this.currentUpdateBusinessPartner = {
              ...this.currentUpdateBusinessPartner,
              ...response.data,
              routes: response.data.routes,
              addresses: response.data.addresses,
            };

            if (this.currentUpdateBusinessPartner.routes?.length > 0) {
              this.filteredRoutes.next(
                this.currentUpdateBusinessPartner.routes
              );
              this.routeMultiCtrl.setValue(
                this.currentUpdateBusinessPartner.routes
              );
            } else {
              this.filteredRoutes.next([]);
              this.routeMultiCtrl.setValue([]);
            }

            if (this.paginator) {
              this.paginator.length =
                this.currentUpdateBusinessPartner.addresses?.length || 0;
            }

            // NOW this check runs AFTER refresh completes (no race condition)
            if (
              hadPrincipalBeforeDeletion &&
              !this.hasPrincipalTerritory() &&
              this.routeMultiCtrl.value.length > 0
            ) {
              this.handlerMessage.warning({
                message:
                  "Se ha eliminado el territorio principal. Por favor, seleccione uno nuevo desde la pestaña de datos generales.",
              });
            }
          }
        },
        error: () => {
          this.handlerMessage.error({
            message: "Error al eliminar la dirección",
          });
        },
      });
  }

  openDeletePhone(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deletePhone(item));
  }

  deletePhone(item: any): void {
    this.phoneService
      .deleteEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.handlerMessage.success({
          message: "Teléfono eliminado con éxito",
        });
        this.phoneService
          .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
          .subscribe((data) => {
            this.currentUpdateBusinessPartner.phones = data?.data;
            this.paginator.length = this.totalItems;
          });
      });
  }

  openDeleteEmail(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteEmail(item));
  }

  deleteEmail(item: any): void {
    this.emailService
      .deleteEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.handlerMessage.success({ message: "Correo eliminado con éxito" });
        this.emailService
          .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
          .subscribe((data) => {
            this.currentUpdateBusinessPartner.emails = data?.data;
            this.paginator.length = this.totalItems;
          });
      });
  }

  openDeleteOrder(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteOrder(item));
  }

  deleteOrder(item: any): void {
    this.orderDeliveryService
      .deleteEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.handlerMessage.success({
          message: "Ventana horaria eliminada con éxito",
        });
        this.orderDeliveryService
          .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
          .subscribe((data) => {
            this.currentUpdateBusinessPartner.orderDeliveryWindows = data?.data;
            this.paginator.length = this.totalItems;
          });
      });
  }

  openDeleteChain(item: any): void {
    this.dialog
      .open(DeleteConfirmationComponent, {
        data: item,
        panelClass: "delete-modal",
        disableClose: true,
      })
      .afterClosed()
      .subscribe((result) => result && this.deleteBusinessPartnerChain(item));
  }

  deleteBusinessPartnerChain(item: any): void {
    this.businessPartnerChainService
      .deleteEmbedded(
        this.currentUpdateBusinessPartner._id.toString(),
        item._id.toString(),
        item
      )
      .subscribe(() => {
        this.handlerMessage.success({
          message: "Cadena de distribución eliminada con éxito",
        });
        this.businessPartnerChainService
          .findByBusinessId(this.currentUpdateBusinessPartner._id.toString())
          .subscribe((data) => {
            this.currentUpdateBusinessPartner.distributionChains = data?.data;
            this.paginator.length = this.totalItems;
          });
      });
  }

  delete(id: string): void {
    this.businessService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.handlerMessage.success({ message: "Registro eliminado con éxito" });
    });
  }

  getSelectedCompanyCodes(selectedCompanyIds: string[]): number[] {
    return selectedCompanyIds.map(
      (id) => this.companyList.find((group) => group._id.toString() === id)?.id
    );
  }

  onRouteAreaSelectionChange(routeAreaId: string): void {
    if (this.currentUpdateBusinessPartner) {
      this.currentUpdateBusinessPartner.routeArea = this.routeAreaList.find(
        (brand) => brand._id.toString() === routeAreaId
      )!;
    }
  }

  onSalesOfficeSelectionChange(salesOfficeId: string): void {
    if (this.currentUpdateBusinessPartner) {
      this.currentUpdateBusinessPartner.routingSalesOffice =
        this.salesOfficeList.find(
          (sales) => sales._id.toString() === salesOfficeId
        )!;
    }
  }

  onBusinessGroupSelectionChange(businessPartnerGroupId: string): void {
    if (this.currentUpdateBusinessPartner) {
      this.currentUpdateBusinessPartner.businessPartnerGroup =
        this.businessGroupList.find(
          (group) => group._id.toString() === businessPartnerGroupId
        )!;
    }
  }

  onBusinessSubGroupSelectionChange(businessPartnerSubGroupId: string): void {
    if (this.currentUpdateBusinessPartner) {
      this.currentUpdateBusinessPartner.businessPartnerSubGroup =
        this.listFilterBusinessSubGroup.find(
          (group) => group._id.toString() === businessPartnerSubGroupId
        )!;
    }
  }

  onPaymentConditionSelectionChange(paymentConditionId: string): void {
    if (this.currentUpdateBusinessPartner) {
      this.currentUpdateBusinessPartner.paymentCondition =
        this.paymentConditionList.find(
          (payment) => payment._id.toString() === paymentConditionId
        )!;
    }
  }

  onCompanySelectionChange(companyIds: string[]): void {
    if (this.currentUpdateBusinessPartner) {
      this.currentUpdateBusinessPartner.companies = companyIds.map(
        (companyId) =>
          this.companyList.find(
            (company) => company._id.toString() === companyId
          )!
      );
    }
  }

  onTypeSelectionChange(selectedTypes: BusinessPartnerTypeAttributes[]): void {
    this.currentUpdateBusinessPartner.types = selectedTypes.map((type) => type);
  }

  onSubRouteSelectionChange(routeIds: string[]): void {
    if (this.currentUpdateBusinessPartner) {
      this.currentUpdateBusinessPartner.routes = routeIds.map(
        (routeId) =>
          this.rutaList.find((sub) => sub._id.toString() === routeId)!
      );
    }
  }

  onBusinessTypeSelectionChange(typeIds: string[]): void {
    if (this.currentUpdateBusinessPartner) {
      this.currentUpdateBusinessPartner.types = typeIds.map(
        (typeId) =>
          this.businessPartnerTypeList.find(
            (sub) => sub._id.toString() === typeId
          )!
      );
    }
  }

  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  // Method to open the Cliente-Territorio import dialog
  openClienteTerritorioImportDialog(): void {
    const dialogRef = this.dialog.open(ImportDialogComponent, {
      data: { config: this.businessPartnerRuteoImportConfig },
      width: "95vw",
      maxWidth: "1400px",
      height: "90vh",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success) {
        this.handlerMessage.success({
          message: "Importación de Cliente-Territorio completada exitosamente",
        });
        this.findAllWithCount(); // Refresh the data
      }
    });
  }

  // Method to open the Cliente-Frecuencia import dialog
  openClienteFrecuenciaImportDialog(): void {
    const dialogRef = this.dialog.open(ImportDialogComponent, {
      data: { config: this.clienteFrecuenciaImportConfig },
      width: "95vw",
      maxWidth: "1400px",
      height: "90vh",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success) {
        this.handlerMessage.success({
          message:
            "Importación de Cliente-Frecuencia-Ruta completada exitosamente",
        });
        this.findAllWithCount(); // Refresh the data
      }
    });
  }

  // Method to open the Business Partner Direcciones import dialog
  openBusinessPartnerDireccionesImportDialog(): void {
    const dialogRef = this.dialog.open(ImportDialogComponent, {
      data: { config: this.businessPartnerDireccionesImportConfig },
      width: "95vw",
      maxWidth: "1400px",
      height: "90vh",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.success) {
        this.handlerMessage.success({
          message:
            "Importación de direcciones de socios de negocio completada exitosamente",
        });
        this.findAllWithCount(); // Refresh the data
      }
    });
  }

  clearFilters(): void {
    this.selectedCompanyIds = [];
    this.searchQuery = "";
    this.selectedRol = [];
    this.selectedTypeCodes = [];
    this.typeSearchCtrl.setValue("");
    this.form = this.fb.group({
      companyId: null,
      businessPartnerRolId: null,
      businessPartnerTypeId: null,
    });
    this.findAllWithCount();
  }

  downloadClienteTerritorioTemplate() {
    const url =
      "https://albatrosfiles.s3.eu-central-1.amazonaws.com/csmobile/business_partner/Cliente-Territorio.xlsx";
    window.open(url);
  }

  downloadClienteFrecuenciaTemplate() {
    const url =
      "https://albatrosfiles.s3.eu-central-1.amazonaws.com/csmobile/business_partner/Cliente-Frecuencia.xlsx";
    window.open(url);
  }

  setImportType(type: "route" | "address") {
    this.importType = type;
  }

  async handleFileInput(event) {
    this.aux_file = true;
    this.fileToUpload = event.target.files[0];
    if (this.fileToUpload) {
      if (
        this.fileToUpload.type !=
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        this.handlerMessage.warning({ message: "Ingrese solo de tipo .xlsx" });
      }
    } else {
      this.aux_file = false;
    }
  }

  onConfirmImportFile(fileInput: HTMLInputElement) {
    if (!this.fileToUpload || !this.importType) return;

    let send = {
      file: this.fileToUpload,
    };
    let formdata = new FormData();
    for (let key in send) {
      formdata.append(key, send[key]);
    }

    let serviceCall;

    if (this.importType === "route") {
      serviceCall = this.subrouteService.importFile(formdata);
    } else if (this.importType === "address") {
      serviceCall = this.businessService.saveImportAddressFile(formdata);
    }

    serviceCall.subscribe({
      next: (res: any) => {
        this.handlerMessage.success({ message: res.message });
        this.resetFileInput(fileInput);
        this.findAllWithCount();
      },
      error: (err) => {
        this.handlerMessage.error({
          message: err?.error?.message,
          alternativeMessage: "Error al subir el archivo",
          statusCode: err?.status,
        });
        this.resetFileInput(fileInput);
      },
    });
  }

  private resetFileInput(fileInput: HTMLInputElement) {
    this.aux_file = false;
    this.fileToUpload = null;
    this.importType = null;
    fileInput.value = "";
  }

  downloadBpAddressTemplate() {
    if (!this.businessPartnerAddressExport.canStartTask()) return;
    this.businessPartnerAddressExport.export(
      ExportFileFormat.Excel,
      ExportRange.AllPages,
      this.totalItems,
      this.pageSize,
      this.pageIndex,
      this.geolocationFilter
    );
  }

  downloadReportBpExcel() {
    if (
      !this.currentUpdateBusinessPartner.addresses ||
      !Array.isArray(this.currentUpdateBusinessPartner.addresses) ||
      this.currentUpdateBusinessPartner.addresses.length === 0
    ) {
      this.handlerMessage.warning({ message: "No cuenta con detalle" });
      return;
    }

    if (!this.businessPartnerByOneAddressExport.canStartTask()) return;

    this.businessPartnerByOneAddressExport.export(
      ExportFileFormat.Excel,
      this.currentUpdateBusinessPartner.addresses,
      this.currentUpdateBusinessPartner.externalKeys.code,
      this.currentUpdateBusinessPartner.name
    );
  }

  openModal(element): void {
    if (this.isNew) {
      const data: MapModalInputData = {
        type: MapModalTypeEnum.SIMPLE,
        tripId: null,
        element: element,
        document: MonitorDocumentTypeEnum.NONE,
        groupDocuments: [],
        map: {
          displayMode: "drawer",
          captions: { title: "Ubicación" },
        },
      };

      this.openMap(data);
    } else {
      this.dialog.open(ModalMapComponent, {
        width: "90%",
        data: element.addresses?.[0],
        disableClose: true,
      });
    }
  }

  openMap(data) {
    this.dialog.open(MapModalComponent, {
      width: "90%",
      //height: '80%',
      data: data,
    });
  }

  onExportButtonPressed() {
    if (!this.businessPartnerExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: BUSINESS_PARTNER_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.businessPartnerExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
          this.geolocationFilter
        );
      }
    });
  }

  // Price List
  openPriceList(businessPartner: BusinessPartnerAttributes): void {
    const dialogRef = this.dialog.open(BusinessPartnerPriceListComponent, {
      panelClass: ".form-modal",
      data: businessPartner,
      width: "850px",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }

  // Horarios de entrega
  openBPschedule(businessPartner: BusinessPartnerAttributes): void {
    const dialogRef = this.dialog.open(BusinessPartnerScheduleComponent, {
      panelClass: ".form-modal",
      data: businessPartner,
      width: "850px",
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
      }
    });
  }

  fetchCategories(): void {
    this.materialGroupService
      .fetchCategories(
        environment.companyId,
        [],
        null //item group
      )
      .subscribe({
        next: (res) => {
          if (res.status == "success") {
            this.materialGroupList = res.data;
            this.materialGroupFilterList = res.data.slice();

            if (this.isProjectTree) {
              let tempTree = [];
              this.getTree(this.categoryPrincipal, "0");
              tempTree.push(this.categoryPrincipal);
              this.listCategories = tempTree[0].children; //el primero es estatico
            } else {
              this.listCategories = this.materialGroupFilterList.slice();
            }
          }
        },
        error: (err) => {
          this.handlerMessage.error({
            message: err?.error?.message,
            alternativeMessage: "Error al obtener categorías",
            statusCode: err?.status,
          });
        },
      });
  }

  getTree(data, fatherCode) {
    data.children = this.materialGroupFilterList.filter(
      (res) => res.fatherCode == fatherCode
    );
    for (let item of data.children) {
      if (item.hasSubcategories) {
        item.children = [];
        this.getTree(item, item.code);
      }
    }
  }

  public filterTree(filterText: string): void {
    let filteredTreeData = [];
    let adicional = [];

    if (filterText) {
      filteredTreeData = this.materialGroupFilterList.filter(
        (d) =>
          d.name.toLocaleLowerCase().indexOf(filterText.toLocaleLowerCase()) >
          -1
      );
      for (let item of filteredTreeData) {
        let fatherCode = item.fatherCode;
        while (fatherCode != "0") {
          let padre = this.materialGroupFilterList.find(
            (res) => res.code == fatherCode
          );
          fatherCode = padre.fatherCode;
          if (!adicional.find((res) => res.code == item.code)) {
            let aux2 = padre;
            delete aux2.children;
            adicional.push(aux2);
          }
        }
      }

      for (let item of adicional) {
        filteredTreeData.push(item);
      }

      var unique = filteredTreeData.filter(function (elem, index, self) {
        return index === self.indexOf(elem);
      });
      filteredTreeData = unique;
    } else {
      filteredTreeData = this.materialGroupFilterList;
    }

    let categoryPrincipalF = {
      name: "Principal",
      code: "0",
      fatherCode: "0",
      hasSubcategories: true,
      level: 0,
      expandable: true,
      children: [],
    };

    this.listFilterCategories = filteredTreeData;
    let categoryNodeFilter = [];
    this.getTreeFilter(categoryPrincipalF, "0");
    categoryNodeFilter.push(categoryPrincipalF);
    this.listCategories = categoryNodeFilter[0].children; //el primero es estatico
  }

  getTreeFilter(data, fatherCode) {
    data.children = this.listFilterCategories.filter(
      (res) => res.fatherCode == fatherCode
    );
    for (let item of data.children) {
      if (item.hasSubcategories) {
        item.children = [];
        this.getTreeFilter(item, item.code);
      }
    }
  }

  changueOptionsGroupMaterial(event) {
    if (!this.materialGroupFilterList) {
      return;
    }
    let search = event;
    if (!search) {
      this.listCategories = this.materialGroupFilterList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    this.listCategories = this.materialGroupFilterList.filter(
      (item) =>
        item.externalKeys?.code.toLowerCase().indexOf(search) > -1 ||
        item.name.toLowerCase().indexOf(search) > -1
    );
  }

  protected filterMultiGroup() {
    if (!this.materialGroupList) {
      return;
    }
    // get the search keyword
    let search = this.groupMultiFilterCtrl.value;
    if (!search) {
      this.filteredGroupCache = this.materialGroupList;
      this.filteredGroup.next(this.materialGroupList);
      return;
    } else {
      search = search.toLowerCase();
    }
    // Filtrar las rutas por nombre o código
    this.filteredGroupCache = this.materialGroupList.filter((material) => {
      const nameMatches = material.name.toLowerCase().indexOf(search) > -1;
      const codeMatches =
        material.externalKeys?.code?.toLowerCase().indexOf(search) > -1;
      return nameMatches || codeMatches; // Devolver true si coincide con el nombre o el código
    });
    this.filteredGroup.next(this.filteredGroupCache);
  }

  protected setToggleAllCheckboxStateGroup() {
    let filteredLength = 0;
    if (this.groupMultiCtrl && this.groupMultiCtrl.value) {
      this.filteredGroupCache.forEach((el) => {
        if (this.groupMultiCtrl.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminateGroup =
        filteredLength > 0 && filteredLength < this.filteredGroupCache.length;
      this.isCheckedGroup =
        filteredLength > 0 && filteredLength === this.filteredGroupCache.length;
    }
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
    this.searchSubscription.unsubscribe();
    // Clean up query params subscriptions
    this.subs.forEach((sub) => sub.unsubscribe());
  }

  toggleValue(): void {
    this.isActive = this.isActive === 1 ? 0 : 1;
    this.findAllWithCount();
  }

  openExportDialog() {
    const dialogRef = this.dialog.open(AddresExportComponent, {
      width: "600px",
      data: { rolList: this.rolList, loadData: true },
    });

    dialogRef.afterClosed().subscribe((exportFilters) => {
      if (exportFilters) {
        this.prepareFiltersAndExport(exportFilters);
      }
    });
  }

  prepareFiltersAndExport(formValues: IFilters) {
    const filters: IFilters = {
      businessPartnerGroupId: formValues.businessPartnerGroupId,
      typeCustomer: formValues.businessPartnerTypeId,
      routeId: formValues.routeId,
      routeAreaId: formValues.routeAreaId,
      subRouteId: formValues.subRouteId,
      locationOneIds: formValues.locationOneIds,
      locationTwoIds: formValues.locationTwoIds,
      locationThreeIds: formValues.locationThreeIds,
    };
    this.businessService
      .findAllWithCount(
        { currentPage: 1, limitPerPage: 1, search: "" },
        false,
        [],
        "",
        filters
      )
      .subscribe((res) => {
        const total = res?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        if (total > 0) {
          this.downloadBpAddressTemplate();
        } else {
          this.handlerMessage.warning({
            message: "No hay datos para exportar",
          });
        }
      });
  }

  /**
   * Abre el diálogo de exportación de direcciones
   */
  openExportDialogRoutes(): void {
    const dialogRef = this._matDialog.open(ExportAddressesDialogComponent, {
      width: "600px",
      maxWidth: "90vw",
      maxHeight: "90vh",
      disableClose: false,
      autoFocus: false,
    });
  }
}
